// App.js

import React, { useState, useMemo, useLayoutEffect } from "react";
import PlanningWorkspace from "./gestion-rh/planning/PlanningWorkspace";

import {
  getSelectedCompanyProfiles,
  selectedCompanyHasProfile,
} from "./utils/activityProfiles";
import { formatUserProfileLabel } from "./utils/userDisplay";

import {

  BrowserRouter as Router,

  Routes,

  Route,

  Link,

  Navigate,

  Outlet,

  useLocation,

  useNavigate,

} from "react-router-dom";

// Import des composants Ant Design

import { Tree, Avatar, Typography, ConfigProvider, theme, notification } from "antd";

// Import des icônes ant-design

import {

  HomeOutlined,

  CalendarOutlined,

  DashboardOutlined,

  TeamOutlined,

  ShopOutlined,

  ShoppingCartOutlined,

  DropboxOutlined,

  ShoppingOutlined,

  BankOutlined,

  WalletOutlined,

  ShopFilled,

  GlobalOutlined,

  BarChartOutlined,

  AppstoreOutlined,

  UserOutlined,

  SettingOutlined,

  InteractionOutlined,

  IdcardOutlined,

  KeyOutlined,

  PercentageOutlined,

  DollarCircleOutlined,

  CreditCardOutlined,

  BellOutlined,

  ContainerOutlined,

  ApartmentOutlined,

  ToolOutlined,

  RocketOutlined,

  FileTextOutlined,

  MonitorOutlined,
  CommentOutlined,

  AuditOutlined,

  LogoutOutlined,

} from "@ant-design/icons";



// Importation des composants existants

import Login from "./auth/Login";

import Signup from "./pages/auth/Signup";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";

import HomePage from "./pages/accueil/HomePage";

import ResponsiveGestionProduit from "./gestion-produits/ResponsiveGestionProduit.jsx";
import ProductTabsLayout, {
  ProductTabsRedirect,
} from "./gestion-produits/ProductTabsLayout.jsx";
import ResponsiveServices from "./gestion-services/ResponsiveServices.jsx";
import ResponsiveRendezVous from "./gestion-rendezvous/ResponsiveRendezVous.jsx";

import ResponsiveEntites from "./gestion-entites/ResponsiveEntites.jsx";
import EntityTabsLayout, {
  EntityTabsRedirect,
} from "./gestion-entites/EntityTabsLayout.jsx";

import ResponsiveGestionAchat from "./gestion-achat/ResponsiveGestionAchat.jsx";
import PurchaseTabsLayout, {
  PurchaseTabsRedirect,
} from "./gestion-achat/PurchaseTabsLayout.jsx";
import GestionBonCommande from "./gestion-bon-commande/GestionBonCommande.tsx";

import ResponsiveRetourAchat from "./gestion-retour-achat/ResponsiveRetourAchat.jsx";

import ResponsiveGestionVente from "./gestion-vente/ResponsiveGestionVente.jsx";
import ResponsiveLivraisons from "./gestion-vente/ResponsiveLivraisons.jsx";
import SalesTabsLayout, {
  SalesTabsRedirect,
} from "./gestion-vente/SalesTabsLayout.jsx";

import ResponsiveRetourVente from "./gestion-retour-vente/ResponsiveRetourVente.jsx";

import GestionPos from "./gestion-pos/GestionPos.tsx";

import ResponsiveGestionStaff from "./gestion-User/ResponsiveGestionStaff.jsx";

import ResponsiveGestionMagasin from "./gestion-magasins/ResponsiveGestionMagasin.jsx";

import ResponsiveGestionRolesPermissions from "./gestion-RolesPermissions/ResponsiveGestionRolesPermissions.jsx";

import ResponsiveGestionTaxes from "./gestion-taxes/ResponsiveGestionTaxes.jsx";

import ResponsiveGestionDevise from "./gestion-devise/ResponsiveGestionDevise.jsx";

import ResponsiveGestionModePaiement from "./gestion-ModePaiement/ResponsiveGestionModePaiement.jsx";

import ResponsiveUnits from "./gestion-unites/ResponsiveUnits.jsx";

import ResponsiveBrands from "./gestion-brands/ResponsiveBrands.jsx";

import ResponsiveCategories from "./gestion-categories/ResponsiveCategories.jsx";

import ResponsiveGestionCompanies from "./gestion-entreprises/ResponsiveGestionCompanies.jsx";

import ResponsiveProforma from "./gestion-proforma/ResponsiveProforma.jsx";

import ResponsiveGestionStock from "./gestion-stock/ResponsiveGestionStock.jsx";

import RightSideNav from "./RightSideNav.jsx";

import { SelectionProvider, useSelection } from "./SelectionContext";
import { setCompanySuspensionNotificationApi } from "./utils/companySuspensionNotice";
import { isSubscriptionPortalOnlyForCompany } from "./utils/subscriptionCompanyScope";

import { ThemeProvider, useTheme } from "./context/ThemeContext";

import NotificationSettings from "./gestion-notifications/NotificationSettings.tsx";

import NotificationsList from "./gestion-notifications/NotificationsList.tsx";

import ResponsiveNotifications from "./gestion-notifications/ResponsiveNotifications";

import NotificationBell from "./components/NotificationBell.tsx";
import NetworkStatusBanner from "./components/NetworkStatusBanner.tsx";
import SubscriptionBillingBanner from "./components/SubscriptionBillingBanner.tsx";
import { NotificationUnreadProvider } from "./context/NotificationUnreadContext.tsx";

import ThemeToggle from "./components/ThemeToggle";

import TrialCountdownBadge from "./components/TrialCountdownBadge.jsx";

import PricingModal from "./components/PricingModal.jsx";

import UserProfileModal from "./components/UserProfileModal";
import DailyRecapBriefingManager from "./components/DailyRecapBriefingManager.tsx";
import MobileBottomNav from "./mobile/MobileBottomNav";
import MobileContextSelectors from "./mobile/MobileContextSelectors";
import MobileHomeHeader from "./mobile/MobileHomeHeader";
import MobileNavDrawer from "./mobile/MobileNavDrawer";

import "./App.css";

import "./styles/elsa-header-c.css";

import "./App.mobile.css"; // Styles spécifiques mobile
import "./mobile/mobile-shell.css";
import "./mobile/mobile-nav-drawer.css";

import ResponsivePaymentSortant from "./gestion-payments/ResponsivePaymentSortant.jsx";

import ResponsivePaymentEntrant from "./gestion-payments/ResponsivePaymentEntrant.jsx";

/// Importation des composants de production

import {

  ProductionKitchen,

  ProductionUnitForm,

  ProductionProcess,

  ProductionRegularization,

  ProductionBatchProcess,

  ProductionLandingRedirect,

  ProductionTabsLayout,

} from "./GestionProductions";
import { getProductionTerminology } from "./GestionProductions/productionTerminology";
import ResponsiveProductionUnits from "./GestionProductions/ResponsiveProductionUnits";
import ResponsiveProductionProcess from "./GestionProductions/ResponsiveProductionProcess";
import ResponsiveProductionHistory from "./GestionProductions/ResponsiveProductionHistory";
import ProductionEquipmentList from "./GestionProductions/ProductionEquipmentList";

import RestaurantOrders from "./gestion-vente/RestaurantOrders";
import RestaurantDigitalMenu from "./gestion-vente/RestaurantDigitalMenu.tsx";

// Import des nouveaux composants Dépenses

import ResponsiveGestionCategoriesDepenses from "./gestion-depenses/ResponsiveGestionCategoriesDepenses.jsx";
import AdminExpensesTabsLayout, {
  AdminExpensesTabsRedirect,
} from "./gestion-depenses/AdminExpensesTabsLayout.jsx";

import ResponsiveGestionSaisieDepenses from "./gestion-depenses/ResponsiveGestionSaisieDepenses.jsx";

import CommercialReports from "./gestion-rapport/CommercialReports.jsx";

import ResponsiveGestionTresorerie from "./gestion-tresoreries/ResponsiveGestionTresorerie.jsx";

import ResponsiveGestionTresorerieConsolidee from "./gestion-tresoreries/ResponsiveGestionTresorerieConsolidee.jsx";

import { AuthProvider, useAuth } from "./context/AuthContext";

// Import du nouveau composant Dashboard

import Dashboard from "./gestion-dashboard/Dashboard";

import SecureLogger from "./utils/secureLogger.js";



// Import des nouveaux composants E-commerce

import ResponsiveCommandesEnLigne from "./gestion-ecommerce/ResponsiveCommandesEnLigne.jsx";
import EcommerceTabsLayout, {
  EcommerceTabsRedirect,
} from "./gestion-ecommerce/EcommerceTabsLayout.jsx";

import ResponsiveConfigurationBoutique from "./gestion-ecommerce/ResponsiveConfigurationBoutique.jsx";

import ReviewPage from "./boutique-publique/ReviewPage.tsx";

import ResponsiveProduitsEnLigne from "./gestion-ecommerce/ResponsiveProduitsEnLigne.jsx";

import ResponsiveParametresBoutique from "./gestion-ecommerce/ResponsiveParametresBoutique.jsx";

import ResponsiveGestionAvis from "./gestion-ecommerce/ResponsiveGestionAvis.jsx";



// Import du Dashboard Monitoring Serveur

import ServerMonitoring from "./gestion-monitoring/ServerMonitoring.jsx";
import BackupMonitoring from "./gestion-monitoring/BackupMonitoring.jsx";
import RecipeAssistantSettings from "./GestionProductions/RecipeAssistantSettings.jsx";



// Import des composants Audit Log

import ResponsiveAuditDashboard from "./gestion-audit/ResponsiveAuditDashboard.jsx";

import ResponsiveAuditLogs from "./gestion-audit/ResponsiveAuditLogs.jsx";
import ResponsiveAuditConnections from "./gestion-audit/ResponsiveAuditConnections.jsx";
import ResponsiveAuditSessions from "./gestion-audit/ResponsiveAuditSessions.jsx";
import AuditTabsLayout, {
  AuditTabsRedirect,
} from "./gestion-audit/AuditTabsLayout.jsx";



// Import des composants boutique publique

import StoreFront from "./boutique-publique/StoreFront.tsx";

import Checkout from "./boutique-publique/Checkout.tsx";
import PaymentReturn from "./boutique-publique/PaymentReturn.tsx";

import PublicMenu from "./menu-public/PublicMenu.tsx";



// Import de la configuration API centralisée

import API_CONFIG from "./config/api";



// Import du module RH

import EmployeeListWrapper from "./gestion-rh/components/EmployeeListWrapper.tsx";

import DepartmentListWrapper from "./gestion-rh/components/DepartmentListWrapper.tsx";

import PositionListWrapper from "./gestion-rh/components/PositionListWrapper.tsx";

import ContractListWrapper from "./gestion-rh/contracts/ContractListWrapper.tsx";

import ContractTypeListWrapper from "./gestion-rh/contract-types/ContractTypeListWrapper.tsx";

import HRDashboardWrapper from "./gestion-rh/components/HRDashboardWrapper.tsx";

import { PayrollItemsList } from "./gestion-rh/payroll-items";

import TaxLegislationList from "./gestion-rh/tax-legislation/TaxLegislationList.tsx";

import CompanyLegislationDashboard from "./gestion-rh/tax-legislation/CompanyLegislationDashboard.tsx";

import CompanyLegislationManager from "./gestion-rh/tax-legislation/CompanyLegislationManager.tsx";

import PayrollProcessing from "./gestion-rh/payroll-processing/PayrollProcessing.tsx";

import PayslipListWrapper from "./gestion-rh/components/PayslipListWrapper.tsx";

import NaturaBenefitsWrapper from "./gestion-rh/components/NaturaBenefitsWrapper.tsx";

import ReportsWrapper from "./gestion-rh/components/ReportsWrapper.tsx";



// Import du module Logistics

import ResponsiveLogisticsDashboard from "./gestion-logistics/ResponsiveLogisticsDashboard.jsx";

import ResponsiveShipmentList from "./gestion-logistics/ResponsiveShipmentList.jsx";

import ResponsiveShipmentDetail from "./gestion-logistics/ResponsiveShipmentDetail.jsx";

import ResponsiveAccountMasterManager from "./gestion-logistics/ResponsiveAccountMasterManager.jsx";

import ResponsiveShipmentReports from "./gestion-logistics/ResponsiveShipmentReports.jsx";

import ResponsiveLogisticsTreasury from "./gestion-logistics/ResponsiveLogisticsTreasury.jsx";
import ResponsiveLogisticsExpenses from "./gestion-logistics/ResponsiveLogisticsExpenses.jsx";
import LogisticsPayments from "./gestion-logistics/payments/LogisticsPayments.jsx";



// Import du module Hotellerie

import GestionHotellerie from "./gestion-hotellerie";



// Import des composants Souscription

import GestionSouscription from "./gestion-souscription/GestionSouscription.tsx";

import SubscriptionPlans from "./gestion-souscription/SubscriptionPlans.tsx";

import TransactionHistory from "./gestion-souscription/TransactionHistory.tsx";

import SubscriptionDashboard from "./gestion-souscription/SubscriptionDashboard.tsx";

import GestionFactures from "./gestion-souscription/GestionFactures.tsx";



// Import des nouvelles pages de guides

import GuidesLandingPage from "./pages/guides/GuidesLandingPage.jsx";

import GuideDetailPage from "./pages/guides/GuideDetailPage.jsx";

import SupportPage from "./pages/support/SupportPage.jsx";
import FeedbackWidget from "./components/FeedbackWidget.tsx";
import FeedbackInbox from "./gestion-feedback/FeedbackInbox.tsx";



// Import de la nouvelle Landing Page "Restaurant & Commerce" (refonte)
// Ancienne landing conservée dans ./pages/ElsaLandingPage (débranchée)

import RestaurantLandingPage from "./pages/RestaurantLandingPage";

import ElsaAdaptiveEmblem from "./components/branding/ElsaAdaptiveEmblem";

import { Helmet, HelmetProvider } from "react-helmet-async"; // SEO

import PaymentPage from "./pages/PaymentPage";



// Import des pages légales

import TermsOfService from "./pages/legal/TermsOfService";

import PrivacyPolicy from "./pages/legal/PrivacyPolicy";

import CookiePolicy from "./pages/legal/CookiePolicy";

import LegalNotice from "./pages/legal/LegalNotice";

import GDPR from "./pages/legal/GDPR";



// Destructuration des composants Ant Design

const { Text } = Typography;

const COMMERCIAL_REPORT_VIEW_PERMISSIONS = [

  "Gestion Commerciale.Rapports.view",

  "Gestion Commerciale.Rapports.ClotureJournaliere.view",

  "Gestion Commerciale.Rapports.VentesMultiPeriode.view",

  "Gestion Commerciale.Rapports.Rentabilite.view",

  "Gestion Commerciale.Rapports.CompteResultat.view",

  "Gestion Commerciale.Rapports.ValorisationStock.view",

];

const PRODUCTION_EQUIPMENT_VIEW_PERMISSION =
  "Gestion Commerciale.Approvisionnement.Production.Materiels.view";



// Composant pour vérifier si l'utilisateur a au moins une permission pour un module

const ModuleProtectedRoute = ({ children, modulePrefix }) => {

  const { isAuthenticated, isLoading, user } = useAuth();



  if (isLoading) {

    return (

      <div className="flex justify-center items-center h-screen">

        Chargement des permissions...

      </div>

    );

  }



  if (!isAuthenticated) {

    return <Navigate to="/login" replace />;

  }



  // Le super administrateur a toujours accès

  if (user && user.is_superadmin) {

    return children;

  }



  // Vérifier si l'utilisateur a au moins une permission qui commence par le préfixe du module

  const hasModuleAccess =

    user?.permissions?.some((p) => p.startsWith(modulePrefix)) ?? false;



  if (!hasModuleAccess) {

    return <Navigate to="/acces-refuse" replace />;

  }



  return children;

};



// Amélioré avec useLocation pour un meilleur suivi de navigation

const PermissionRefresher = () => {

  const { refreshUserPermissions } = useAuth();

  const location = useLocation();



  // Rafraîchir les permissions lorsque l'utilisateur navigue vers des modules importants

  React.useEffect(() => {

    // Liste des chemins importants où les permissions doivent être vérifiées

    const importantPaths = [

      "/gestion-produits",
      "/gestion-services",
      "/gestion-rendez-vous",

      "/gestion-entites",

      "/gestion-achats",
      "/gestion-achat",

      "/gestion-bon-commande",

      "/gestion-ventes",
      "/gestion-vente",

      "/gestion-charges-admin",

      "/gestion-ecommerce",

      "/gestion-pos",

      "/gestion-personnel",

      "/gestion-roles-permissions",

      "/gestion-entreprises",

      "/hotellerie",

      // Ajoutez d'autres chemins selon vos besoins

    ];



    // Si l'utilisateur navigue vers un module important, rafraîchir les permissions

    if (importantPaths.some((path) => location.pathname.startsWith(path))) {

      SecureLogger.debug(

        "Navigation to important module, refreshing permissions"

      );

      refreshUserPermissions(false); // false = ne pas forcer si récemment rafraîchi

    }

  }, [location.pathname, refreshUserPermissions]); // Ajout de refreshUserPermissions aux dépendances



  // Ce composant ne rend rien, il effectue simplement son effet secondaire

  return null;

};



// --- Composant pour les Routes Protégées (Modifié) ---

const ProtectedRoute = ({ children }) => {

  const { isAuthenticated, isLoading, user } = useAuth();
  const { selectedCompany } = useSelection();

  const location = useLocation();



  if (isLoading) {

    return (

      <div className="flex justify-center items-center h-screen">

        Chargement de l'authentification...

      </div>

    );

  }



  if (!isAuthenticated) {

    return <Navigate to="/login" replace />;

  }

  if (

    isSubscriptionPortalOnlyForCompany(user, selectedCompany) &&

    !location.pathname.startsWith("/souscription") &&
    location.pathname !== "/acces-refuse"

  ) {

    return <Navigate to="/souscription" replace />;

  }



  return children;

};



// Route protégée par permission spécifique

const PermissionProtectedRoute = ({ children, requiredPermission }) => {

  const { isAuthenticated, isLoading, hasPermission, user } = useAuth();
  const { selectedCompany } = useSelection();

  const location = useLocation();



  if (isLoading) {

    return (

      <div className="flex justify-center items-center h-screen">

        Chargement des permissions...

      </div>

    );

  }



  if (!isAuthenticated) {

    return <Navigate to="/login" replace />;

  }

  if (

    isSubscriptionPortalOnlyForCompany(user, selectedCompany) &&

    location.pathname !== "/souscription"

  ) {

    return <Navigate to="/souscription" replace />;

  }



  // NOUVEAU: Le super administrateur a toujours accès

  if (user && user.is_superadmin) {

    return children;

  }



  // Vérifier les permissions pour les autres utilisateurs

  const requiredPermissions = (Array.isArray(requiredPermission)
    ? requiredPermission
    : [requiredPermission]
  ).filter(Boolean);

  if (requiredPermissions.length === 0) {

    return children;

  }

  const hasRequiredPermission = requiredPermissions.some((permission) =>
    hasPermission(permission)
  );

  if (!hasRequiredPermission) {

    // Rediriger vers une page d'accès refusé ou la page d'accueil

    return <Navigate to="/acces-refuse" replace />;

  }



  return children;

};

const AccessDeniedPage = () => {
  const { user } = useAuth();
  const { selectedCompany } = useSelection();
  const assignedCompanyIds = new Set(
    (user?.assigned_warehouses || [])
      .map((warehouse) => Number(warehouse.company_id))
      .filter((companyId) => Number.isSafeInteger(companyId) && companyId > 0),
  );
  const canSwitchCompany =
    isSubscriptionPortalOnlyForCompany(user, selectedCompany) &&
    assignedCompanyIds.size > 1;

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Accès refusé</h1>
      <p>Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
      {canSwitchCompany && (
        <>
          <p>Vous pouvez sélectionner une autre entreprise autorisée.</p>
          <div className="app-context-bar__desktop-context"><RightSideNav /></div>
          <div className="app-context-bar__mobile-context"><MobileContextSelectors /></div>
        </>
      )}
      <Link to="/accueil">Retour à l'accueil</Link>
    </div>
  );
};



const SysAdminProtectedRoute = ({ children }) => {

  const { isAuthenticated, isLoading, user } = useAuth();



  if (isLoading) {

    return (

      <div className="flex justify-center items-center h-screen">

        Chargement des permissions...

      </div>

    );

  }



  if (!isAuthenticated) {

    return <Navigate to="/login" replace />;

  }



  if (!user?.is_superadmin) {

    return <Navigate to="/acces-refuse" replace />;

  }



  return children;

};



// --- Fonction utilitaire pour détecter les appareils tactiles ---

const isTouchDevice = () => {

  return (

    "ontouchstart" in window ||

    navigator.maxTouchPoints > 0 ||

    navigator.msMaxTouchPoints > 0

  );

};



// --- Composant pour le Layout Principal ---

const MainAppLayout = () => {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [menuForceClose, setMenuForceClose] = useState(false);

  const [pricingModalVisible, setPricingModalVisible] = useState(false);

  const [openSubmenus, setOpenSubmenus] = useState({

    gestionCommerciale: false,

    entites: false,

    produits: false,

    approvisionnement: false,

    achats: false,

    production: false,

    ventes: false,

    stock: false,

    ecommerce: false,

    depenses: false,

    admin: false,

    "ecommerce-config": false,

    staff: false,

    magasins: false,

    rolesPermissions: false,

    userCompanies: false,

    settings: false,

    ventesPos: false,

    ventesEcommerce: false,

    retoursVente: false,

    proformas: false,

    achatsDirects: false,

    retoursAchat: false,

    rh: false,

    rhPersonnel: false,

    rhPaie: false,

    rhTemps: false,

    logistics: false,

    hotellerie: false,

    menuGlobal: false,

  });



  // États pour le Tree component (mobile uniquement)

  const [treeExpandedKeys, setTreeExpandedKeys] = useState([]);

  const [treeSelectedKeys, setTreeSelectedKeys] = useState([]);



  // États pour le profil utilisateur (mobile uniquement)

  const [isProfileModalVisible, setIsProfileModalVisible] = useState(false);

  const [imageError, setImageError] = useState(false);
  const [isMobileViewport, setIsMobileViewport] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );



  const { user, logout } = useAuth();
  const { selectedCompany } = useSelection();
  const { toggleTheme } = useTheme();
  const userProfileLabel = useMemo(
    () => formatUserProfileLabel(user),
    [user]
  );
  const selectedCompanyProfiles = getSelectedCompanyProfiles(
    user,
    selectedCompany
  );
  const selectedCompanyIsRestaurant = selectedCompanyHasProfile(
    user,
    selectedCompany,
    "restaurant"
  );
  const productionTerminology = getProductionTerminology(
    selectedCompanyProfiles
  );

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const handleViewportChange = () => {
      setIsMobileViewport(window.innerWidth <= 768);
    };

    handleViewportChange();
    window.addEventListener("resize", handleViewportChange);
    return () => window.removeEventListener("resize", handleViewportChange);
  }, []);



  // Fonction pour obtenir l'URL de l'image utilisateur (utilise la configuration centralisée)

  const getImageUrl = (imagePath) => {

    if (!imagePath) return undefined;

    if (imagePath.startsWith("http")) return imagePath;

    const path = imagePath.startsWith("/")

      ? imagePath

      : `/uploads/profiles/${imagePath}`;

    return `${API_CONFIG.BASE_URL}${path}`;

  };



  const menuHierarchy = useMemo(

    () => ({

      gestionCommerciale: [

        "entites",

        "produits",

        "approvisionnement",

        "achats",

        "production",

        "ventes",

        "stock",

        "ecommerce",

        "depenses",

      ],

      admin: [

        "staff",

        "magasins",

        "rolesPermissions",

        "userCompanies",

        "settings",

        "ecommerce-config",

      ],

      ventes: ["ventesPos", "ventesEcommerce", "retoursVente", "proformas"],

      achats: ["achatsDirects", "retoursAchat"],

      rh: ["rhPersonnel", "rhPaie", "rhTemps"],

      menuGlobal: ["tresorerieConsolidee"],

    }),

    []

  );



  const getAllDescendantKeys = React.useCallback(

    (itemName, hierarchy, currentOpenState) => {

      let descendants = [];

      const directChildren = hierarchy[itemName] || [];

      for (const child of directChildren) {

        if (currentOpenState.hasOwnProperty(child)) {

          descendants.push(child);

          descendants = descendants.concat(

            getAllDescendantKeys(child, hierarchy, currentOpenState)

          );

        }

      }

      return descendants;

    },

    [] // Removed menuHierarchy and openSubmenus, as they might cause stale closures if not updated.

    // Let toggleSubmenu handle current state directly from its closure or props.

  );



  const userPermissions = useMemo(

    () => new Set(user?.permissions || []),

    [user]

  );



  const hasPermission = React.useCallback(

    (permissionKey) => {

      // SysAdmin a toujours accès à tout

      if (user && (user.is_superadmin || user.role === "SysAdmin")) {

        return true;

      }



      // useCallback for stable function reference

      return userPermissions.has(permissionKey);

    },

    [userPermissions, user]

  );



  const canAccessCommercialReports = React.useMemo(

    () =>

      COMMERCIAL_REPORT_VIEW_PERMISSIONS.some((permission) =>

        hasPermission(permission)

      ),

    [hasPermission]

  );



  const hasAnyPermissionInModule = React.useCallback(

    (modulePrefix) => {

      // SysAdmin a toujours accès à tout

      if (user && (user.is_superadmin || user.role === "SysAdmin")) {

        return true;

      }



      // useCallback

      if (!user?.permissions) return false;

      return user.permissions.some((p) => p.startsWith(modulePrefix));

    },

    [user]

  );



  // Fonction helper pour rendre les noeuds parents non-sélectionnables

  const makeParentsNonSelectable = React.useCallback((nodes) => {

    return nodes.map(node => {

      const newNode = { ...node };

      // Si le noeud a des enfants, il n'est pas sélectionnable

      if (newNode.children && newNode.children.length > 0) {

        newNode.selectable = false;

        newNode.children = makeParentsNonSelectable(newNode.children);

      }

      return newNode;

    });

  }, []);



  // Fonction pour construire le Tree Data pour mobile

  const buildMenuTreeData = React.useCallback(() => {

    const treeData = [];



    // Accueil (toujours visible)

    treeData.push({

      title:
        selectedCompanyIsRestaurant &&
        hasPermission("Gestion Commerciale.Dashboard.view")
          ? "Pilotage"
          : "Accueil",

      key: "accueil",

      icon: <HomeOutlined />,

      path: "/accueil",

      isLeaf: true,

    });



    // GESTION COMMERCIALE

    if (hasAnyPermissionInModule("Gestion Commerciale.")) {

      const gestionCommercialeChildren = [];



      // Dashboard

      if (hasPermission("Gestion Commerciale.Dashboard.view")) {

        gestionCommercialeChildren.push({

          title: "Tableau de bord",

          key: "tableau-de-bord",

          icon: <DashboardOutlined />,

          path: "/tableau-de-bord",

          isLeaf: true,

        });

      }



      // Gestion Entités

      if (

        hasPermission("Gestion Commerciale.Entites.Clients.view") ||

        hasPermission("Gestion Commerciale.Entites.Fournisseurs.view")

      ) {

        const entitesChildren = [];

        if (hasPermission("Gestion Commerciale.Entites.Clients.view")) {

          entitesChildren.push({

            title: "Clients",

            key: "clients",

            path: "/gestion-entites/clients",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Entites.Fournisseurs.view")) {

          entitesChildren.push({

            title: "Fournisseurs",

            key: "fournisseurs",

            path: "/gestion-entites/fournisseurs",

            isLeaf: true,

          });

        }

        gestionCommercialeChildren.push({

          title: "Gestion Entités",

          key: "gestion-entites",

          icon: <TeamOutlined />,

          children: entitesChildren,

        });

      }



      // Gestion Produits

      if (

        hasPermission("Gestion Commerciale.Produits.Marques.view") ||

        hasPermission("Gestion Commerciale.Produits.Categories.view") ||

        hasPermission("Gestion Commerciale.Produits.Produits.view") ||

        hasPermission("Gestion Commerciale.Services.view") ||

        hasPermission("Gestion Commerciale.RendezVous.view") ||

        hasPermission("Gestion Commerciale.Produits.Unites.view")

      ) {

        const produitsChildren = [];

        if (hasPermission("Gestion Commerciale.Produits.Marques.view")) {

          produitsChildren.push({

            title: "Marques",

            key: "marques",

            path: "/gestion-produits/marques",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Produits.Categories.view")) {

          produitsChildren.push({

            title: "Catégories",

            key: "categories",

            path: "/gestion-produits/categories",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Produits.Produits.view")) {

          produitsChildren.push({

            title: "Produits",

            key: "produits",

            path: "/gestion-produits/produits",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Services.view")) {

          produitsChildren.push({

            title: "Services",

            key: "services-commerciaux",

            path: "/gestion-produits/services",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.RendezVous.view")) {

          produitsChildren.push({

            title: "Rendez-vous",

            key: "rendez-vous-commerciaux",

            path: "/gestion-produits/rendez-vous",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Produits.Unites.view")) {

          produitsChildren.push({

            title: "Unités",

            key: "unites",

            path: "/gestion-produits/unites",

            isLeaf: true,

          });

        }

        gestionCommercialeChildren.push({

          title: "Gestion Produits",

          key: "gestion-produits-menu",

          icon: <ShopOutlined />,

          children: produitsChildren,

        });

      }



      // Approvisionnement

      if (

        hasAnyPermissionInModule("Gestion Commerciale.Approvisionnement.Achats.") ||

        hasAnyPermissionInModule("Gestion Commerciale.Approvisionnement.Production.")

      ) {

        const approChildren = [];



        // Achats

        if (

          hasPermission("Gestion Commerciale.Approvisionnement.Achats.Achat.view") ||

          hasPermission("Gestion Commerciale.Approvisionnement.Achats.BonCommande.view") ||

          hasPermission("Gestion Commerciale.Approvisionnement.Achats.RetourAchat.view") ||

          hasPermission("Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.view")

        ) {

          const achatsChildren = [];

          if (hasPermission("Gestion Commerciale.Approvisionnement.Achats.Achat.view")) {

            achatsChildren.push({

              title: "Achat",

              key: "achat",

              path: "/gestion-achats/achat",

              isLeaf: true,

            });

          }

          if (hasPermission("Gestion Commerciale.Approvisionnement.Achats.BonCommande.view")) {

            achatsChildren.push({

              title: "Bon de commande",

              key: "bon-commande",

              path: "/gestion-achats/bon-commande",

              isLeaf: true,

            });

          }

          if (hasPermission("Gestion Commerciale.Approvisionnement.Achats.RetourAchat.view")) {

            achatsChildren.push({

              title: "Retour d'achat",

              key: "retour-achat",

              path: "/gestion-achats/retour-achat",

              isLeaf: true,

            });

          }

          if (hasPermission("Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.view")) {

            achatsChildren.push({

              title: "Paiements Sortants",

              key: "paiements-sortants",

              path: "/gestion-achats/paiements-sortants",

              isLeaf: true,

            });

          }

          approChildren.push({

            title: "Gestion Achats",

            key: "gestion-achats",

            children: achatsChildren,

          });

        }



        // Production

      if (

        hasPermission("Gestion Commerciale.Approvisionnement.Production.Unites.view") ||

        hasPermission("Gestion Commerciale.Approvisionnement.Production.Gerer.view") ||

        hasPermission("Gestion Commerciale.Approvisionnement.Production.Historique.view") ||

        (selectedCompanyIsRestaurant &&

          hasPermission("Gestion Commerciale.Restauration.Cuisine.view"))

      ) {

          const productionChildren = [];

          if (hasPermission("Gestion Commerciale.Approvisionnement.Production.Unites.view")) {

            productionChildren.push({

              title: productionTerminology.unitsTitle,

              key: "production-units",

              path: "/production/units",

              isLeaf: true,

            });

          }

          if (hasPermission("Gestion Commerciale.Approvisionnement.Production.Gerer.view")) {

            productionChildren.push({

              title: productionTerminology.manageTitle,

              key: "production-process",

              path: "/production/process",

              isLeaf: true,

            });

          }

          if (hasPermission("Gestion Commerciale.Approvisionnement.Production.Historique.view")) {

            productionChildren.push({

              title: productionTerminology.historyTitle,

              key: "production-history",

              path: "/production/history",

              isLeaf: true,

            });

          }

          if (
            selectedCompanyIsRestaurant &&
            hasPermission("Gestion Commerciale.Restauration.Cuisine.view")
          ) {

            productionChildren.push({

              title: "File cuisine",

              key: "production-kitchen",

              path: "/production/kitchen",

              isLeaf: true,

            });

          }

          approChildren.push({

            title: productionTerminology.moduleTitle,

            key: "gestion-production",

            children: productionChildren,

          });

        }



        gestionCommercialeChildren.push({

          title: "Approvisionnement",

          key: "approvisionnement",

          icon: <ShoppingCartOutlined />,

          children: approChildren,

        });

      }



      // Ventes

      if (

        (selectedCompanyIsRestaurant &&
          hasPermission("Gestion Commerciale.Restauration.CommandesSalle.view")) ||

        (selectedCompanyIsRestaurant &&
          hasPermission("Gestion Commerciale.Restauration.MenuDigital.view")) ||

        hasPermission("Gestion Commerciale.Ventes.Ventes.view") ||

        hasPermission("Gestion Commerciale.Ventes.RetourVente.view") ||

        hasPermission("Gestion Commerciale.Ventes.ProformaDevis.view") ||

        hasPermission("Gestion Commerciale.Ventes.PaiementsEntrants.view")

      ) {

        const ventesChildren = [];

        if (
          selectedCompanyIsRestaurant &&
          hasPermission("Gestion Commerciale.Restauration.CommandesSalle.view")
        ) {

          ventesChildren.push({

            title: "Prise de commande",

            key: "commandes-restaurant",

            path: "/gestion-ventes/commandes-restaurant",

            isLeaf: true,

          });

        }

        if (
          selectedCompanyIsRestaurant &&
          hasPermission("Gestion Commerciale.Restauration.MenuDigital.view")
        ) {

          ventesChildren.push({

            title: "Menu digital",

            key: "menu-digital-restaurant",

            path: "/gestion-ventes/menu-digital",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Ventes.Ventes.view")) {

          ventesChildren.push({

            title: "Ventes",

            key: "ventes",

            path: "/gestion-ventes/ventes",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Ventes.RetourVente.view")) {

          ventesChildren.push({

            title: "Retour de vente",

            key: "retour-vente",

            path: "/gestion-ventes/retour-vente",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Ventes.Livraisons.view")) {

          ventesChildren.push({

            title: "Livraisons",

            key: "livraisons",

            path: "/gestion-ventes/livraisons",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Ventes.ProformaDevis.view")) {

          ventesChildren.push({

            title: "Proforma/Devis",

            key: "proforma",

            path: "/gestion-ventes/proforma",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Ventes.PaiementsEntrants.view")) {

          ventesChildren.push({

            title: "Paiements Entrants",

            key: "paiements-entrants",

            path: "/gestion-ventes/paiements-entrants",

            isLeaf: true,

          });

        }

        gestionCommercialeChildren.push({

          title: "Gestion Ventes",

          key: "gestion-ventes",

          icon: <ShoppingOutlined />,

          children: ventesChildren,

        });

      }



      // Stock

      if (

        hasPermission("Gestion Commerciale.Stock.GestionStock.Transfer.view") ||

        hasPermission("Gestion Commerciale.Stock.GestionStock.Adjust.view") ||

        hasPermission("Gestion Commerciale.Stock.GestionStock.History.view")

      ) {

        gestionCommercialeChildren.push({

          title: "Gestion Stock",

          key: "gestion-stock",

          icon: <DropboxOutlined />,

          path: "/gestion-stock",

          isLeaf: true,

        });

      }



      // Trésorerie

      if (hasAnyPermissionInModule("Gestion Commerciale.Tresorerie.")) {

        gestionCommercialeChildren.push({

          title: "Trésoreries",

          key: "tresoreries",

          icon: <BankOutlined />,

          path: "/caisse-banques",

          isLeaf: true,

        });

      }



      // Charges Admin

      if (

        hasPermission("Gestion Commerciale.Depenses.Categories.view") ||

        hasPermission("Gestion Commerciale.Depenses.SaisieDepenses.view")

      ) {

        const depensesChildren = [];

        if (hasPermission("Gestion Commerciale.Depenses.Categories.view")) {

          depensesChildren.push({

            title: "Catégories",

            key: "categories-depenses",

            path: "/gestion-charges-admin/categories",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Depenses.SaisieDepenses.view")) {

          depensesChildren.push({

            title: "Saisie Charges Admin",

            key: "saisie-depenses",

            path: "/gestion-charges-admin/saisie",

            isLeaf: true,

          });

        }

        gestionCommercialeChildren.push({

          title: "Charges Admin",

          key: "depenses",

          icon: <WalletOutlined />,

          children: depensesChildren,

        });

      }



      // E-commerce

      if (hasAnyPermissionInModule("Gestion Commerciale.Ecommerce.")) {

        const ecommerceChildren = [];

        if (hasPermission("Gestion Commerciale.Ecommerce.CommandesEnLigne.view")) {

          ecommerceChildren.push({

            title: "Commandes en ligne",

            key: "commandes-en-ligne",

            path: "/gestion-ecommerce/commandes-en-ligne",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Ecommerce.Configuration.Boutiques.view")) {

          ecommerceChildren.push({

            title: "Configuration boutique",

            key: "configuration-boutique",

            path: "/gestion-ecommerce/configuration-boutique",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Ecommerce.Configuration.FichesProduit.view")) {

          ecommerceChildren.push({

            title: "Fiches produit",

            key: "fiches-produit",

            path: "/gestion-ecommerce/fiches-produit",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Ecommerce.Configuration.Frontend.view")) {

          ecommerceChildren.push({

            title: "Paramètres frontend",

            key: "parametres-frontend",

            path: "/gestion-ecommerce/parametres-frontend",

            isLeaf: true,

          });

        }

        if (hasPermission("Gestion Commerciale.Ecommerce.CommandesEnLigne.view")) {

          ecommerceChildren.push({

            title: "Gestion des Avis",

            key: "avis-clients",

            path: "/gestion-ecommerce/avis-clients",

            isLeaf: true,

          });

        }

        if (ecommerceChildren.length > 0) {

          gestionCommercialeChildren.push({

            title: "E-commerce",

            key: "ecommerce",

            icon: <GlobalOutlined />,

            children: ecommerceChildren,

          });

        }

      }



      // Rapport

      if (canAccessCommercialReports) {

        gestionCommercialeChildren.push({

          title: "Rapport",

          key: "rapport",

          icon: <BarChartOutlined />,

          path: "/rapport",

          isLeaf: true,

        });

      }



      // POS

      if (hasPermission("Gestion Commerciale.POS.use")) {

        gestionCommercialeChildren.push({

          title: "Point de vente",

          key: "pos",

          icon: <ShopOutlined />,

          path: "/gestion-pos",

          isLeaf: true,

        });

      }



      if (gestionCommercialeChildren.length > 0) {

        treeData.push({

          title: "Gestion Commerciale",

          key: "gestion-commerciale",

          icon: <ShopFilled />,

          children: gestionCommercialeChildren,

        });

      }

    }



    // RESSOURCES HUMAINES (complet)

    if (hasAnyPermissionInModule("Ressources Humaines.")) {

      const rhChildren = [];



      // Dashboard RH

      if (hasPermission("Ressources Humaines.Dashboard.view")) {

        rhChildren.push({

          title: "Tableau de bord RH",

          key: "rh-dashboard",

          icon: <DashboardOutlined />,

          path: "/rh/tableau-de-bord",

          isLeaf: true,

        });

      }



      // Gestion Personnel

      if (

        hasPermission("Ressources Humaines.Personnel.Employes.view") ||

        hasPermission("Ressources Humaines.Personnel.Departements.view") ||

        hasPermission("Ressources Humaines.Personnel.Postes.view") ||

        hasPermission("Ressources Humaines.Personnel.Contrats.view")

      ) {

        const personnelChildren = [];



        if (hasPermission("Ressources Humaines.Personnel.Employes.view")) {

          personnelChildren.push({

            title: "Employés",

            key: "rh-employes",

            path: "/rh/employes",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Personnel.Departements.view")) {

          personnelChildren.push({

            title: "Départements",

            key: "rh-departements",

            path: "/rh/departements",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Personnel.Postes.view")) {

          personnelChildren.push({

            title: "Postes",

            key: "rh-postes",

            path: "/rh/postes",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Personnel.Contrats.view")) {

          personnelChildren.push({

            title: "Contrats",

            key: "rh-contrats",

            path: "/rh/contrats",

            isLeaf: true,

          });

          personnelChildren.push({

            title: "Types de contrats",

            key: "rh-types-contrats",

            path: "/rh/types-contrats",

            isLeaf: true,

          });

        }



        rhChildren.push({

          title: "Gestion Personnel",

          key: "rh-personnel",

          icon: <UserOutlined />,

          children: personnelChildren,

        });

      }



      // Paie & Rémunération

      if (hasAnyPermissionInModule("Ressources Humaines.Paie.")) {

        const paieChildren = [];



        if (hasPermission("Ressources Humaines.Paie.TraitementPaie.view")) {

          paieChildren.push({

            title: "Traitement de paie",

            key: "rh-traitement-paie",

            path: "/rh/traitement-paie",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Paie.Bulletins.view")) {

          paieChildren.push({

            title: "Bulletins de paie",

            key: "rh-bulletins",

            path: "/rh/bulletins-paie",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Paie.Elements.view")) {

          paieChildren.push({

            title: "Éléments de paie",

            key: "rh-elements",

            path: "/rh/elements-paie",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Paie.TaxesLegislation.view")) {

          paieChildren.push({

            title: "Taxes et Législation",

            key: "rh-taxes",

            path: "/rh/taxes-legislation",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Paie.TaxesLegislation.manage")) {

          paieChildren.push({

            title: "Législation Fiscale",

            key: "rh-legislation-fiscale",

            path: "/rh/taxes-legislation/manager",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Paie.AvantagesNature.view")) {

          paieChildren.push({

            title: "Avantages en Nature",

            key: "rh-avantages",

            path: "/rh/avantages-nature",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Paie.Grilles.view")) {

          paieChildren.push({

            title: "Grilles salariales",

            key: "rh-grilles",

            path: "/rh/grilles-salariales",

            isLeaf: true,

          });

        }



        rhChildren.push({

          title: "Paie & Rémunération",

          key: "rh-paie",

          icon: <WalletOutlined />,

          children: paieChildren,

        });

      }



      // Temps & Présence

      if (hasAnyPermissionInModule("Ressources Humaines.Temps.")) {

        const tempsChildren = [];



        if (hasPermission("Ressources Humaines.Temps.Pointage.view")) {

          tempsChildren.push({

            title: "Pointage",

            key: "rh-pointage",

            path: "/rh/pointage",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Temps.Conges.view")) {

          tempsChildren.push({

            title: "Congés & absences",

            key: "rh-conges",

            path: "/rh/conges-absences",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Temps.HeuresSupp.view")) {

          tempsChildren.push({

            title: "Heures supplémentaires",

            key: "rh-heures-supp",

            path: "/rh/heures-supplementaires",

            isLeaf: true,

          });

        }

        if (hasPermission("Ressources Humaines.Temps.Planning.view") || hasPermission("Ressources Humaines.Temps.Planning.manage_access")) {

          tempsChildren.push({

            title: "Planning de travail",

            key: "rh-planning",

            path: "/rh/planning",

            isLeaf: true,

          });

        }



        rhChildren.push({

          title: "Temps & Présence",

          key: "rh-temps",

          icon: <BankOutlined />,

          children: tempsChildren,

        });

      }



      // Rapports & Déclarations

      if (hasPermission("Ressources Humaines.Rapports.view")) {

        rhChildren.push({

          title: "Rapports & Déclarations",

          key: "rh-rapports",

          icon: <BarChartOutlined />,

          path: "/rh/rapports",

          isLeaf: true,

        });

      }



      if (rhChildren.length > 0) {

        treeData.push({

          title: "Ressources Humaines",

          key: "ressources-humaines",

          icon: <TeamOutlined />,

          children: rhChildren,

        });

      }

    }



    // MENU GLOBAL

    if (hasPermission("Finance.TresorerieConsolidee.view")) {

      treeData.push({

        title: "Menu global",

        key: "menu-global",

        icon: <BankOutlined />,

        children: [

          {

            title: "Tresorerie consolidee",

            key: "tresorerie-consolidee",

            path: "/tresorerie-consolidee",

            isLeaf: true,

          },

        ],

      });

    }



    // LOGISTICS (complet) - Attention: "logistics." avec minuscule !

    if (hasAnyPermissionInModule("logistics.")) {

      const logisticsChildren = [];



      if (hasPermission("logistics.dashboard.view")) {

        logisticsChildren.push({

          title: "Tableau de bord",

          key: "logistics-dashboard",

          icon: <DashboardOutlined />,

          path: "/logistique/tableau-de-bord",

          isLeaf: true,

        });

      }

      if (hasPermission("logistics.shipments.view")) {

        logisticsChildren.push({

          title: "Dossiers",

          key: "logistics-dossiers",

          icon: <FileTextOutlined />,

          path: "/logistique/dossiers",

          isLeaf: true,

        });

      }

      if (hasPermission("logistics.customer_payments.view")) {
        logisticsChildren.push({ title: "Paiements Entrants", key: "logistics-paiements-entrants",
          icon: <DollarCircleOutlined />, path: "/logistique/paiements-entrants", isLeaf: true });
      }
      if (hasPermission("logistics.supplier_payments.view") || hasPermission("logistics.expenses.entries.view_payments")) {
        logisticsChildren.push({ title: "Paiements Sortants", key: "logistics-paiements-sortants",
          icon: <DollarCircleOutlined />, path: "/logistique/paiements-sortants", isLeaf: true });
      }
      if (hasPermission("logistics.treasury.view")) {

        logisticsChildren.push({

          title: "Trésorerie",

          key: "logistics-treasorerie",

          icon: <DollarCircleOutlined />,

          path: "/logistique/tresorerie",

          isLeaf: true,

        });

      }
      if (hasPermission("logistics.expenses.entries.view") ||
        hasPermission("logistics.expenses.categories.view")
      ) {
        logisticsChildren.push({
          title: "Charges Admin",
          key: "logistics-depenses",
          icon: <WalletOutlined />,
          path: "/logistique/depenses",
          isLeaf: true,
        });
      }


      if (hasPermission("logistics.reports.view")) {

        logisticsChildren.push({

          title: "Rapports",

          key: "logistics-rapports",

          icon: <BarChartOutlined />,

          path: "/logistique/rapports",

          isLeaf: true,

        });

      }

      if (hasPermission("logistics.account_masters.view")) {

        logisticsChildren.push({

          title: "Configuration",

          key: "logistics-config",

          icon: <SettingOutlined />,

          path: "/logistique/configuration",

          isLeaf: true,

        });

      }



      if (logisticsChildren.length > 0) {

        treeData.push({

          title: "Logistique",

          key: "logistics",

          icon: <ContainerOutlined />,

          children: logisticsChildren,

        });

      }

    }



    // HOTELLERIE

    if (hasAnyPermissionInModule("Hotellerie.")) {

      const hotelChildren = [];



      if (hasPermission("Hotellerie.Reservations.view")) {

        hotelChildren.push({

          title: "Reservations",

          key: "hotel-reservations",

          icon: <CalendarOutlined />,

          path: "/hotellerie?tab=reservations",

          isLeaf: true,

        });

      }

      if (hasPermission("Hotellerie.Configuration.Chambres.view")) {

        hotelChildren.push({

          title: "Chambres & disponibilites",

          key: "hotel-rooms",

          icon: <HomeOutlined />,

          path: "/hotellerie?tab=rooms",

          isLeaf: true,

        });

      }

      if (

        hasPermission("Hotellerie.Tarifs.PlansTarifaires.view") ||

        hasPermission("Hotellerie.Tarifs.Calendrier.view")

      ) {

        hotelChildren.push({

          title: "Tarifs",

          key: "hotel-rates",

          icon: <DollarCircleOutlined />,

          path: "/hotellerie?tab=rates",

          isLeaf: true,

        });

      }

      if (hasPermission("Hotellerie.Clients.view")) {

        hotelChildren.push({

          title: "Clients",

          key: "hotel-guests",

          icon: <TeamOutlined />,

          path: "/hotellerie?tab=guests",

          isLeaf: true,

        });

      }

      if (hasPermission("Hotellerie.Comptes.view")) {

        hotelChildren.push({

          title: "Comptes",

          key: "hotel-accounts",

          icon: <BankOutlined />,

          path: "/hotellerie?tab=accounts",

          isLeaf: true,

        });

      }

      if (hasPermission("Hotellerie.Folios.view")) {

        hotelChildren.push({

          title: "Folios",

          key: "hotel-folios",

          icon: <FileTextOutlined />,

          path: "/hotellerie?tab=folios",

          isLeaf: true,

        });

      }

      if (hasPermission("Hotellerie.Services.view")) {

        hotelChildren.push({

          title: "Services",

          key: "hotel-services",

          icon: <AppstoreOutlined />,

          path: "/hotellerie?tab=services",

          isLeaf: true,

        });

      }

      if (

        hasPermission("Hotellerie.Operations.Housekeeping.view") ||

        hasPermission("Hotellerie.Operations.Maintenance.view")

      ) {

        hotelChildren.push({

          title: "Operations",

          key: "hotel-operations",

          icon: <ToolOutlined />,

          path: "/hotellerie?tab=operations",

          isLeaf: true,

        });

      }

      if (hasPermission("Hotellerie.Paiements.view")) {

        hotelChildren.push({

          title: "Paiements",

          key: "hotel-payments",

          icon: <DollarCircleOutlined />,

          path: "/hotellerie?tab=payments",

          isLeaf: true,

        });

      }
      if (
        hasPermission("Hotellerie.Depenses.Categories.view") ||
        hasPermission("Hotellerie.Depenses.SaisieDepenses.view")
      ) {
        hotelChildren.push({
          title: "Charges Admin",
          key: "hotel-expenses",
          icon: <WalletOutlined />,
          path: "/hotellerie?tab=expenses",
          isLeaf: true,
        });
      }


      if (

        hasPermission("Hotellerie.Configuration.Proprietes.view") ||

        hasPermission("Hotellerie.Configuration.Batiments.view") ||

        hasPermission("Hotellerie.Configuration.Etages.view") ||

        hasPermission("Hotellerie.Configuration.TypesChambres.view") ||

        hasPermission("Hotellerie.Configuration.Amenites.view")

      ) {

        hotelChildren.push({

          title: "Configuration",

          key: "hotel-config",

          icon: <SettingOutlined />,

          path: "/hotellerie?tab=configuration",

          isLeaf: true,

        });

      }



      if (hotelChildren.length > 0) {

        treeData.push({

          title: "Hotellerie",

          key: "hotellerie",

          icon: <ApartmentOutlined />,

          children: hotelChildren,

        });

      }

    }



    // ADMIN

    if (hasAnyPermissionInModule("Admin.")) {

      const adminChildren = [];



      if (hasPermission("Souscription.MonAbonnement.view")) {

        adminChildren.push({

          title: user?.is_superadmin ? "Souscriptions" : "Ma souscription",

          key: "souscription",

          icon: <IdcardOutlined />,

          path: "/souscription",

          isLeaf: true,

        });

      }

      if (hasPermission("Admin.GestionEntreprises.view")) {

        adminChildren.push({

          title: "Gestion Entreprises",

          key: "gestion-entreprises",

          icon: <BankOutlined />,

          path: "/gestion-entreprises",

          isLeaf: true,

        });

      }

      if (hasPermission("Admin.GestionUtilisateurs.view")) {

        adminChildren.push({

          title: "Utilisateurs",

          key: "utilisateurs",

          icon: <UserOutlined />,

          path: "/gestion-personnel",

          isLeaf: true,

        });

      }

      if (hasPermission("Admin.Magasins.view")) {

        adminChildren.push({

          title: "Établissement",

          key: "magasin",

          icon: <ShopOutlined />,

          path: "/gestion-magasin",

          isLeaf: true,

        });

      }

      if (hasPermission("Admin.RolesPermissions.view")) {

        adminChildren.push({

          title: "Rôles et permissions",

          key: "roles-permissions",

          icon: <KeyOutlined />,

          path: "/gestion-roles-permissions",

          isLeaf: true,

        });

      }

      if (hasPermission("Admin.Taxes.view")) {

        adminChildren.push({

          title: "Taxes",

          key: "taxes",

          icon: <PercentageOutlined />,

          path: "/gestion-taxes",

          isLeaf: true,

        });

      }

      if (hasPermission("Admin.Devises.view")) {

        adminChildren.push({

          title: "Devise",

          key: "devise",

          icon: <DollarCircleOutlined />,

          path: "/gestion-devise",

          isLeaf: true,

        });

      }

      if (hasPermission("Admin.ModesPaiement.view")) {

        adminChildren.push({

          title: "Mode de paiement",

          key: "mode-paiement",

          icon: <CreditCardOutlined />,

          path: "/gestion-mode-paiement",

          isLeaf: true,

        });

      }

      if (user?.is_superadmin || hasPermission("Notifications.manage_settings")) {

        adminChildren.push({

          title: "Notifications",

          key: "notifications",

          icon: <BellOutlined />,

          path: "/notification-settings",

          isLeaf: true,

        });

      }



      // Monitoring Serveur - SuperAdmin uniquement

      if (Number(user?.is_superadmin) === 1) {
        adminChildren.push({
          title: "Retours utilisateurs",
          key: "retours-utilisateurs",
          icon: <CommentOutlined />,
          path: "/retours-utilisateurs",
          isLeaf: true,
        });
      }

      if (user?.is_superadmin) {

        adminChildren.push({

          title: "Monitoring Serveur",

          key: "server-monitoring",

          icon: <MonitorOutlined />,

          path: "/server-monitoring",

          isLeaf: true,

        });

      }



      // Sauvegardes MySQL - SuperAdmin uniquement

      if (user?.is_superadmin) {

        adminChildren.push({

          title: "Sauvegardes",

          key: "backup-monitoring",

          icon: <DropboxOutlined />,

          path: "/backup-monitoring",

          isLeaf: true,

        });

      }



      // Reglages Moteur Recettes - SuperAdmin uniquement

      if (user?.is_superadmin) {

        adminChildren.push({

          title: "Réglages Moteur Recettes",

          key: "recipe-assistant-settings",

          icon: <SettingOutlined />,

          path: "/recipe-assistant-settings",

          isLeaf: true,

        });

      }



      // Audit Log - Admin/SuperAdmin uniquement

      if (user?.is_superadmin || user?.permissions?.includes("view_audit_logs")) {

        adminChildren.push({

          title: "Journal d'Audit",

          key: "audit",

          icon: <AuditOutlined />,

          children: [
            { title: "Tableau de bord", key: "audit-dashboard", path: "/audit/dashboard", isLeaf: true },
            { title: "Journal d'audit", key: "audit-logs", path: "/audit/logs", isLeaf: true },
            { title: "Connexions", key: "audit-connections", path: "/audit/connexions", isLeaf: true },
            { title: "Sessions actives", key: "audit-sessions", path: "/audit/sessions", isLeaf: true },
          ],

        });

      }



      if (adminChildren.length > 0) {

        treeData.push({

          title: "Admin",

          key: "admin",

          icon: <SettingOutlined />,

          children: adminChildren,

        });

      }

    }



    // Rendre tous les noeuds parents non-sélectionnables avant de retourner

    return makeParentsNonSelectable(treeData);

  }, [
    hasPermission,
    hasAnyPermissionInModule,
    canAccessCommercialReports,
    makeParentsNonSelectable,
    productionTerminology,
    selectedCompanyIsRestaurant,
    user,
  ]);



  // Calculer le treeData avec useMemo

  const menuTreeData = useMemo(() => buildMenuTreeData(), [buildMenuTreeData]);

  // Le drawer mobile garde la navigation globale, mais regroupe les nombreux
  // écrans Admin en sous-ensembles lisibles. Le Tree desktop conserve sa
  // structure actuelle.
  const mobileMenuTreeData = useMemo(() => {
    const organizationKeys = new Set([
      "gestion-entreprises",
      "utilisateurs",
      "magasin",
      "roles-permissions",
    ]);
    const financeKeys = new Set(["taxes", "devise", "mode-paiement"]);

    return menuTreeData.map((node) => {
      if (node.key !== "admin" || !node.children?.length) return node;

      const organization = node.children.filter((child) =>
        organizationKeys.has(child.key)
      );
      const finance = node.children.filter((child) => financeKeys.has(child.key));
      const system = node.children.filter(
        (child) =>
          !organizationKeys.has(child.key) && !financeKeys.has(child.key)
      );
      const groups = [
        organization.length
          ? {
              title: "Organisation",
              key: "admin-organization",
              icon: <BankOutlined />,
              selectable: false,
              children: organization,
            }
          : null,
        finance.length
          ? {
              title: "Configuration financière",
              key: "admin-finance",
              icon: <DollarCircleOutlined />,
              selectable: false,
              children: finance,
            }
          : null,
        system.length
          ? {
              title: "Système et contrôle",
              key: "admin-system",
              icon: <SettingOutlined />,
              selectable: false,
              children: system,
            }
          : null,
      ].filter(Boolean);

      return { ...node, children: groups };
    });
  }, [menuTreeData]);



  // Gestionnaires pour le Tree component (mobile)

  const onTreeSelect = React.useCallback((selectedKeys, info) => {

    const node = info.node;



    // Ne rien faire si le noeud a des enfants (c'est un parent qu'on veut juste expand/collapse)

    if (node.children && node.children.length > 0) {

      return;

    }



    // Si le noeud a un path ET est une feuille, naviguer vers ce path

    if (node.path && node.isLeaf) {

      navigate(node.path);

      // Fermer le menu mobile après navigation

      setMobileMenuOpen(false);

      setTreeExpandedKeys([]);

      setTreeSelectedKeys([]);

    }

  }, [navigate]);



  const onTreeExpand = React.useCallback((expandedKeys) => {

    setTreeExpandedKeys(expandedKeys);

  }, []);



  // Fonction pour rendre le titre cliquable et permettre expand/collapse

  const handleTitleClick = React.useCallback((node, e) => {

    // Si le noeud a des enfants, toggle l'expansion

    if (node.children && node.children.length > 0) {

      e.stopPropagation(); // Empêcher le onSelect de se déclencher

      const isExpanded = treeExpandedKeys.includes(node.key);

      if (isExpanded) {

        // Replier : retirer la clé

        setTreeExpandedKeys(treeExpandedKeys.filter(key => key !== node.key));

      } else {

        // Déplier : ajouter la clé

        setTreeExpandedKeys([...treeExpandedKeys, node.key]);

      }

    }

  }, [treeExpandedKeys]);



  const resetAllMobileVisualStates = () => {

    if (typeof document !== "undefined") {

      document

        .querySelectorAll(

          ".submenu.visible, .submenu2.visible, .submenu3.visible"

        )

        .forEach((el) => {

          el.classList.remove("visible");

        });

      document

        .querySelectorAll(

          ".submenu-indicator.open, .submenu-indicator-right.open"

        )

        .forEach((el) => {

          el.classList.remove("open");

        });

    }

  };



  const toggleMobileMenu = () => {

    const newMobileMenuOpen = !mobileMenuOpen;

    setMobileMenuOpen(newMobileMenuOpen);

    if (!newMobileMenuOpen) {

      setOpenSubmenus((prevState) =>

        Object.keys(prevState).reduce(

          (acc, key) => ({ ...acc, [key]: false }),

          {}

        )

      );

      resetAllMobileVisualStates();

    }

  };



  const handleLinkClick = () => {

    setMobileMenuOpen(false);

    setMenuForceClose(true); // This helps ensure desktop hover menus don't immediately pop open

    // Close all submenus logically

    setOpenSubmenus((prevState) =>

      Object.keys(prevState).reduce(

        (acc, key) => ({ ...acc, [key]: false }),

        {}

      )

    );

    // Reset visual states for mobile, though it might be redundant if mobileMenuOpen is false

    resetAllMobileVisualStates();

  };



  const toggleSubmenu = (submenuName, event) => {

    if (event) {

      event.preventDefault();

      event.stopPropagation();

    }



    // Détection améliorée : mobile OU appareil tactile

    const isMobileOrTouch = window.innerWidth <= 768 || isTouchDevice();



    if (isMobileOrTouch) {

      const parentLi = event.currentTarget.closest("li");

      if (!parentLi) return;



      const submenuElement = parentLi.querySelector(

        ":scope > .submenu, :scope > .submenu2, :scope > .submenu3"

      );

      const indicatorElement = event.currentTarget.querySelector(

        ".submenu-indicator, .submenu-indicator-right"

      );



      if (!submenuElement) return;



      const isCurrentlyOpenForState = openSubmenus[submenuName];



      // Ajouter/retirer la classe 'open' sur l'indicateur pour l'animation

      if (indicatorElement) {

        if (isCurrentlyOpenForState) {

          indicatorElement.classList.remove("open");

        } else {

          indicatorElement.classList.add("open");

        }

      }



      setOpenSubmenus((prevOpenSubmenus) => {

        const newOpenState = { ...prevOpenSubmenus };



        // If the clicked menu is currently open, close it and all its descendants

        if (isCurrentlyOpenForState) {

          newOpenState[submenuName] = false;

          const descendantKeys = getAllDescendantKeys(

            submenuName,

            menuHierarchy,

            prevOpenSubmenus

          );

          descendantKeys.forEach((key) => {

            if (newOpenState.hasOwnProperty(key)) newOpenState[key] = false;

          });

        } else {

          // If the clicked menu is closed, open it.

          // Optionally, close sibling submenus at the same level first.

          const parentUl = parentLi.parentElement;

          if (parentUl) {

            Array.from(parentUl.children).forEach((siblingLi) => {

              if (siblingLi !== parentLi && siblingLi.dataset.submenuName) {

                const siblingKey = siblingLi.dataset.submenuName;

                if (newOpenState[siblingKey]) {

                  // if sibling is open

                  newOpenState[siblingKey] = false;

                  const siblingDescendants = getAllDescendantKeys(

                    siblingKey,

                    menuHierarchy,

                    prevOpenSubmenus

                  );

                  siblingDescendants.forEach((descKey) => {

                    if (newOpenState.hasOwnProperty(descKey))

                      newOpenState[descKey] = false;

                  });

                }

              }

            });

          }

          newOpenState[submenuName] = true;

        }

        return newOpenState;

      });

    }

  };



  // Gestion du redimensionnement de la fenêtre

  React.useEffect(() => {

    const handleResize = () => {

      if (window.innerWidth > 768) {

        // Tailwind's 'md' breakpoint

        if (mobileMenuOpen) {

          // If mobile menu was open and we resized to desktop

          setMobileMenuOpen(false); // Close mobile menu

          // Reset all submenu states, as desktop relies on hover (or different logic)

          setOpenSubmenus((prevState) =>

            Object.keys(prevState).reduce(

              (acc, key) => ({ ...acc, [key]: false }),

              {}

            )

          );

          resetAllMobileVisualStates(); // Clean up any mobile-specific classes

        }

      } else {

        // Mobile view

        // Clear any desktop-only forced close when switching to mobile

        setMenuForceClose(false);

      }

    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);

  }, [mobileMenuOpen]);



  // Fermeture du menu au clic/touch en dehors (mobile uniquement)

  React.useEffect(() => {

    if (!mobileMenuOpen || isMobileViewport) return;



    const handleClickOutside = (e) => {

      const menu = document.querySelector(".menu");

      const mobileTreeMenu = document.querySelector(".mobile-tree-menu");

      const toggle = document.querySelector(".menu-toggle, .ea-tab--menu");



      // Vérifier si le clic est dans le menu mobile Tree OU le menu desktop

      const isInsideMobileMenu = mobileTreeMenu && mobileTreeMenu.contains(e.target);

      const isInsideDesktopMenu = menu && menu.contains(e.target);

      const isToggle = toggle && toggle.contains(e.target);



      // Si le clic est en dehors de TOUS les menus ET du bouton hamburger

      if (!isInsideMobileMenu && !isInsideDesktopMenu && !isToggle) {

        setMobileMenuOpen(false);

        // Fermer tous les sous-menus

        setOpenSubmenus((prev) =>

          Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {})

        );

        setTreeExpandedKeys([]);

        setTreeSelectedKeys([]);

        resetAllMobileVisualStates();

      }

    };



    // Utiliser 'touchstart' pour mobile et 'mousedown' pour desktop

    document.addEventListener("touchstart", handleClickOutside);

    document.addEventListener("mousedown", handleClickOutside);



    return () => {

      document.removeEventListener("touchstart", handleClickOutside);

      document.removeEventListener("mousedown", handleClickOutside);

    };

  }, [isMobileViewport, mobileMenuOpen]);



  // Bloquer le scroll du body quand le menu mobile est ouvert

  React.useEffect(() => {

    if (isMobileViewport) return undefined;

    if (mobileMenuOpen && window.innerWidth <= 768) {

      document.body.style.overflow = "hidden";

    } else {

      document.body.style.overflow = "";

    }



    return () => {

      document.body.style.overflow = "";

    };

  }, [isMobileViewport, mobileMenuOpen]);



  const handleNavMouseEnter = () => {

    if (window.innerWidth > 768) {

      // Only apply for desktop

      setMenuForceClose(false);

    }

  };



  // R?f?'?,©active les hovers desktop d?f?'?,¨s le premier mouvement de souris apr?f?'?,¨s un clic

  React.useEffect(() => {

    if (!menuForceClose) return;

    if (typeof window === "undefined") return;

    if (window.innerWidth <= 768 || isTouchDevice()) return;



    const handleMouseMove = () => {

      setMenuForceClose(false);

    };



    window.addEventListener("mousemove", handleMouseMove, { once: true });



    return () => {

      window.removeEventListener("mousemove", handleMouseMove);

    };

  }, [menuForceClose]);



  const handleLogout = () => {

    logout();

    // Optionally navigate to login or home page after logout

    // navigate('/login'); // if you have access to navigate function

  };

  const isAccueilRoute =
    location.pathname === "/accueil" || location.pathname === "/accueil/";
  const isMobileProductsRoute =
    location.pathname === "/gestion-produits" ||
    location.pathname.startsWith("/gestion-produits/");
  const isMobilePosRoute =
    location.pathname === "/gestion-pos" ||
    location.pathname.startsWith("/gestion-pos/");
  const isMobileNotificationsRoute =
    location.pathname === "/notifications" ||
    location.pathname.startsWith("/notifications/");
  const isMobileStockRoute = location.pathname === "/gestion-stock";
  // Routes rendues par un écran .epm (qui se borne lui-même au viewport).
  // ⚠️ À garder synchronisée avec MOBILE_SHELL_ROUTES dans SalesTabsLayout.jsx.
  const isMobileVentesRoute =
    /^\/gestion-ventes\/(ventes|paiements-entrants|proforma|livraisons|retour-vente)/.test(
      location.pathname
    );
  const isMobileAchatsRoute =
    /^\/gestion-achats\/(achat|bon-commande|retour-achat|paiements-sortants)/.test(
      location.pathname
    );
  const isMobileEntitesRoute = location.pathname.startsWith("/gestion-entites/");
  const isMobileTreasuryExpensesRoute =
    location.pathname === "/caisse-banques" ||
    location.pathname === "/tresorerie-consolidee" ||
    /^\/gestion-charges-admin\/(categories|saisie)/.test(location.pathname);
  const isMobileAdminRoute = /^\/gestion-(entreprises|personnel|magasin|roles-permissions|taxes|devise|mode-paiement)\/?$/.test(
    location.pathname
  );
  const isMobileLogisticsRoute =
    location.pathname.startsWith("/logistique/") ||
    location.pathname.startsWith("/logistics/shipment/");
  const isMobileEcommerceRoute = location.pathname.startsWith("/gestion-ecommerce/");
  const isMobileAuditRoute = location.pathname.startsWith("/audit/");
  // Uniquement les écrans production rendus via .pm-root (bottom sheets ancrés au
  // viewport). Les autres enfants de /production (formulaire d'unité, cuisine,
  // régularisation…) sont des pages longues qui doivent continuer à défiler.
  const isMobileProductionRoute =
    /^\/production\/(units|history)\/?$/.test(location.pathname) ||
    /^\/production\/process(\/[^/]+)?\/?$/.test(location.pathname);
  const useMobileShell = isMobileViewport;
  const mobileHeaderUserName = String(
    user?.first_name || user?.prenom || user?.name || user?.username || ""
  )
    .trim()
    .split(/\s+/)[0];

  const mobileMenuRouteState = useMemo(() => {
    let selectedKey;
    let selectedPathLength = -1;
    let expandedKeys = [];
    const activeMenuPath = location.pathname.startsWith("/logistics/shipment/")
      ? "/logistique/dossiers"
      : location.pathname;

    const visit = (nodes, ancestors = []) => {
      nodes.forEach((node) => {
        if (
          node.path &&
          (activeMenuPath === node.path ||
            activeMenuPath.startsWith(`${node.path}/`)) &&
          node.path.length > selectedPathLength
        ) {
          selectedKey = node.key;
          selectedPathLength = node.path.length;
          expandedKeys = ancestors;
        }

        if (node.children?.length) {
          visit(node.children, [...ancestors, node.key]);
        }
      });
    };

    visit(mobileMenuTreeData);
    return { selectedKey, expandedKeys };
  }, [location.pathname, mobileMenuTreeData]);

  // Ferme le drawer mobile à chaque navigation (ex. clic sur la cloche qui
  // route vers /notifications depuis le drawer/menu).
  React.useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (

    <div
      className={`app-container ${useMobileShell ? "ea-mobile-shell" : ""} ${
        useMobileShell && isAccueilRoute ? "ea-mobile-home" : ""
      } ${useMobileShell && isMobileProductsRoute ? "ea-mobile-products" : ""} ${
        useMobileShell && isMobilePosRoute ? "ea-mobile-pos" : ""
      } ${
        useMobileShell && isMobileNotificationsRoute
          ? "ea-mobile-notifications"
          : ""
      } ${
        useMobileShell && isMobileProductionRoute ? "ea-mobile-production" : ""
      } ${useMobileShell && isMobileStockRoute ? "ea-mobile-stock" : ""} ${
        useMobileShell && isMobileVentesRoute ? "ea-mobile-ventes" : ""
      } ${useMobileShell && isMobileAchatsRoute ? "ea-mobile-achats" : ""} ${
        useMobileShell && isMobileEntitesRoute ? "ea-mobile-entites" : ""
      } ${
        useMobileShell && isMobileTreasuryExpensesRoute
          ? "ea-mobile-treasury-expenses"
          : ""
      } ${
        useMobileShell && isMobileAdminRoute ? "ea-mobile-admin" : ""
      } ${
        useMobileShell && isMobileLogisticsRoute ? "ea-mobile-logistics" : ""
      } ${
        useMobileShell && isMobileEcommerceRoute ? "ea-mobile-ecommerce" : ""
      } ${
        useMobileShell && isMobileAuditRoute ? "ea-mobile-audit" : ""
      }`}
    >

      <PermissionRefresher />

      {useMobileShell && isAccueilRoute && (
        <MobileHomeHeader
          userName={mobileHeaderUserName}
          onAvatar={() => setIsProfileModalVisible(true)}
          notificationSlot={
            user?.is_superadmin || hasPermission("Notifications.view") ? (
              <NotificationBell className="ea-header__notification" />
            ) : null
          }
        />
      )}

      {useMobileShell && (
        <MobileNavDrawer
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          treeData={mobileMenuTreeData}
          selectedKey={mobileMenuRouteState.selectedKey}
          defaultExpandedKeys={mobileMenuRouteState.expandedKeys}
          onSelect={(node) => onTreeSelect([node.key], { node })}
          user={user}
          getImageUrl={getImageUrl}
          onProfile={() => {
            setIsProfileModalVisible(true);
            setMobileMenuOpen(false);
          }}
          onLogout={handleLogout}
          onToggleTheme={toggleTheme}
          notificationSlot={
            user?.is_superadmin || hasPermission("Notifications.view") ? (
              <NotificationBell />
            ) : null
          }
        />
      )}

      {!useMobileShell && (
      <header className="main-header app-shell__header">

        <div className="logo-container app-shell__logo">

          <Link
            to={user ? "/accueil" : "/"}
            onClick={handleLinkClick}
            className="app-shell__brand-link"
            aria-label="ELSA GESTION"
          >

            <ElsaAdaptiveEmblem className="logo-image" alt="" />

            <span className="app-shell__brand-wordmark" aria-hidden="true">
              <span className="app-shell__brand-line app-shell__brand-line--elsa">
                ELSA
              </span>
              <span className="app-shell__brand-line app-shell__brand-line--gestion">
                GESTION
              </span>
            </span>

          </Link>

        </div>

        <nav className="main-nav app-shell__nav" onMouseEnter={handleNavMouseEnter}>

          <div
            className="menu-toggle app-shell__menu-toggle"
            onClick={toggleMobileMenu}
            role="button"
            aria-label="Ouvrir le menu principal"
            aria-expanded={mobileMenuOpen}
          >

            <span className="hamburger-line"></span>

            <span className="hamburger-line"></span>

            <span className="hamburger-line"></span>

          </div>



          {/* VERSION MOBILE : Tree Component d'Ant Design */}

          <div

            className={`mobile-tree-menu ${mobileMenuOpen ? "open" : ""}`}

          >

            {/* Section Profil Utilisateur Mobile */}

            <div

              className="mobile-user-profile"

              onClick={() => { setIsProfileModalVisible(true); setMobileMenuOpen(false); }}

            >

              <Avatar

                size={48}

                src={user?.profile_image && !imageError ? getImageUrl(user.profile_image) : undefined}

                icon={<UserOutlined />}

                className="mobile-user-avatar"

                onError={() => setImageError(true)}

                onLoad={() => setImageError(false)}

              />

              <div className="mobile-user-info">

                <Text
                  className="mobile-user-name"
                  title={userProfileLabel}
                >

                  {userProfileLabel}

                </Text>

              </div>

            </div>



            <Tree

              showIcon

              treeData={menuTreeData}

              selectedKeys={treeSelectedKeys}

              expandedKeys={treeExpandedKeys}

              onSelect={onTreeSelect}

              onExpand={onTreeExpand}

              titleRender={(node) => (

                <span

                  onClick={(e) => handleTitleClick(node, e)}

                  style={{ cursor: node.children && node.children.length > 0 ? 'pointer' : 'default' }}

                >

                  {node.title}

                </span>

              )}


              className="mobile-nav-tree"

            />

            {/* Actions mobile : Notifications et Déconnexion */}

            <div className="mobile-tree-actions">

              {(user?.is_superadmin || hasPermission("Notifications.view")) && (

                <div className="mobile-tree-action-item">

                  <NotificationBell />

                </div>

              )}

              <div className="mobile-tree-action-item">

                <a

                  href="#"

                  onClick={handleLogout}

                  className="mobile-logout-link"

                  title="Déconnexion"

                  aria-label="Déconnexion"

                >

                  <LogoutOutlined className="mobile-logout-icon" />

                </a>

              </div>

            </div>

          </div>



          {/* VERSION DESKTOP : Menu ul/li classique */}

          <ul

            className={`menu desktop-menu desktop-menu--primary ${menuForceClose ? "force-close" : ""}`}

          >

            <li className="menu-item">

              <Link to="/accueil" onClick={handleLinkClick}>

                <HomeOutlined className="menu-icon" /> Accueil

              </Link>

            </li>



            {/* --- GESTION COMMERCIALE --- */}

            {hasAnyPermissionInModule("Gestion Commerciale.") && (

              <li

                className="menu-item has-submenu"

                data-submenu-name="gestionCommerciale"

              >

                <span onClick={(e) => toggleSubmenu("gestionCommerciale", e)}>

                  <ShopFilled className="menu-icon" /> Gestion Commerciale{" "}

                  <span

                    className={`submenu-indicator ${

                      openSubmenus.gestionCommerciale ? "open" : ""

                    }`}

                  >

                    {openSubmenus.gestionCommerciale ? "\u25B4" : "\u25BE"}

                  </span>

                </span>

                <ul

                  className={`submenu ${

                    openSubmenus.gestionCommerciale ? "visible" : ""

                  }`}

                >

                  {" "}

                  {hasPermission("Gestion Commerciale.Dashboard.view") && (

                    <li>

                      <Link to="/tableau-de-bord" onClick={handleLinkClick}>

                        <DashboardOutlined className="menu-icon" /> Tableau de

                        bord

                      </Link>

                    </li>

                  )}

                  {(hasPermission("Gestion Commerciale.Entites.Clients.view") ||

                    hasPermission(

                      "Gestion Commerciale.Entites.Fournisseurs.view"

                    )) && (

                    <li className="has-submenu" data-submenu-name="entites">

                      <a href="#" onClick={(e) => toggleSubmenu("entites", e)}>

                        {" "}

                        <TeamOutlined className="menu-icon" /> Gestion Entités{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.entites ? "open" : ""

                          }`}

                        >

                          {openSubmenus.entites ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.entites ? "visible" : ""

                        }`}

                      >

                        {" "}

                        {hasPermission(

                          "Gestion Commerciale.Entites.Clients.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-entites/clients"

                              onClick={handleLinkClick}

                            >

                              Clients

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Entites.Fournisseurs.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-entites/fournisseurs"

                              onClick={handleLinkClick}

                            >

                              Fournisseurs

                            </Link>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {(hasPermission(

                    "Gestion Commerciale.Produits.Marques.view"

                  ) ||

                    hasPermission(

                      "Gestion Commerciale.Produits.Categories.view"

                    ) ||

                    hasPermission(

                      "Gestion Commerciale.Produits.Produits.view"

                    ) ||

                    hasPermission(

                      "Gestion Commerciale.Services.view"

                    ) ||

                    hasPermission(

                      "Gestion Commerciale.RendezVous.view"

                    ) ||

                    hasPermission(

                      "Gestion Commerciale.Produits.Unites.view"

                    )) && (

                    <li className="has-submenu" data-submenu-name="produits">

                      <a href="#" onClick={(e) => toggleSubmenu("produits", e)}>

                        <ShopOutlined className="menu-icon" /> Gestion Produits{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.produits ? "open" : ""

                          }`}

                        >

                          {openSubmenus.produits ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.produits ? "visible" : ""

                        }`}

                      >

                        {" "}

                        {hasPermission(

                          "Gestion Commerciale.Produits.Marques.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-produits/marques"

                              onClick={handleLinkClick}

                            >

                              Marques

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Produits.Categories.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-produits/categories"

                              onClick={handleLinkClick}

                            >

                              Catégories

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Produits.Produits.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-produits/produits"

                              onClick={handleLinkClick}

                            >

                              Produits

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Services.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-produits/services"

                              onClick={handleLinkClick}

                            >

                              Services

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.RendezVous.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-produits/rendez-vous"

                              onClick={handleLinkClick}

                            >

                              Rendez-vous

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Produits.Unites.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-produits/unites"

                              onClick={handleLinkClick}

                            >

                              Unités

                            </Link>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {(hasAnyPermissionInModule(

                    "Gestion Commerciale.Approvisionnement.Achats."

                  ) ||

                    hasAnyPermissionInModule(

                      "Gestion Commerciale.Approvisionnement.Production."

                    )) && (

                    <li

                      className="has-submenu"

                      data-submenu-name="approvisionnement"

                    >

                      <a

                        href="#"

                        onClick={(e) => toggleSubmenu("approvisionnement", e)}

                      >

                        <ShoppingCartOutlined className="menu-icon" />{" "}

                        Approvisionnement{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.approvisionnement ? "open" : ""

                          }`}

                        >

                          {openSubmenus.approvisionnement ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.approvisionnement ? "visible" : ""

                        }`}

                      >

                        {" "}

                        {(hasPermission(

                          "Gestion Commerciale.Approvisionnement.Achats.Achat.view"

                        ) ||

                          hasPermission(

                            "Gestion Commerciale.Approvisionnement.Achats.BonCommande.view"

                          ) ||

                          hasPermission(

                            "Gestion Commerciale.Approvisionnement.Achats.RetourAchat.view"

                          ) ||

                          hasPermission(

                            "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.view"

                          )) && (

                          <li

                            className="has-submenu"

                            data-submenu-name="achats"

                          >

                            <a

                              href="#"

                              onClick={(e) => toggleSubmenu("achats", e)}

                            >

                              Gestion Achats{" "}

                              <span

                                className={`submenu-indicator submenu-indicator-right ${

                                  openSubmenus.achats ? "open" : ""

                                }`}

                              >

                                {openSubmenus.achats ? "\u25B4" : "\u25BE"}

                              </span>

                            </a>

                            <ul

                              className={`submenu3 ${

                                openSubmenus.achats ? "visible" : ""

                              }`}

                            >

                              {" "}

                              {hasPermission(

                                "Gestion Commerciale.Approvisionnement.Achats.Achat.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/gestion-achats/achat"

                                    onClick={handleLinkClick}

                                  >

                                    Achat

                                  </Link>

                                </li>

                              )}

                              {hasPermission(

                                "Gestion Commerciale.Approvisionnement.Achats.BonCommande.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/gestion-achats/bon-commande"

                                    onClick={handleLinkClick}

                                  >

                                    Bon de commande

                                  </Link>

                                </li>

                              )}

                              {hasPermission(

                                "Gestion Commerciale.Approvisionnement.Achats.RetourAchat.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/gestion-achats/retour-achat"

                                    onClick={handleLinkClick}

                                  >

                                    Retour d'achat

                                  </Link>

                                </li>

                              )}

                              {hasPermission(

                                "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/gestion-achats/paiements-sortants"

                                    onClick={handleLinkClick}

                                  >

                                    Paiements Sortants

                                  </Link>

                                </li>

                              )}

                            </ul>

                          </li>

                        )}

                        {(hasPermission(
                          "Gestion Commerciale.Approvisionnement.Production.Unites.view"
                        ) ||
                          hasPermission(
                            "Gestion Commerciale.Approvisionnement.Production.Gerer.view"
                          ) ||
                          hasPermission(
                            "Gestion Commerciale.Approvisionnement.Production.Historique.view"
                          ) ||
                          (selectedCompanyIsRestaurant &&
                            hasPermission(
                              "Gestion Commerciale.Restauration.Cuisine.view"
                            ))) && (

                          <li

                            className="has-submenu"

                            data-submenu-name="production"

                          >

                            <a

                              href="#"

                              onClick={(e) => toggleSubmenu("production", e)}

                            >

                              {productionTerminology.moduleTitle}{" "}

                              <span

                                className={`submenu-indicator submenu-indicator-right ${

                                  openSubmenus.production ? "open" : ""

                                }`}

                              >

                                {openSubmenus.production ? "\u25B4" : "\u25BE"}

                              </span>

                            </a>

                            <ul

                              className={`submenu3 ${

                                openSubmenus.production ? "visible" : ""

                              }`}

                            >

                              {" "}

                              {hasPermission(

                                "Gestion Commerciale.Approvisionnement.Production.Unites.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/production/units"

                                    onClick={handleLinkClick}

                                  >

                                    {productionTerminology.unitsTitle}

                                  </Link>

                                </li>

                              )}

                              {hasPermission(

                                "Gestion Commerciale.Approvisionnement.Production.Gerer.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/production/process"

                                    onClick={handleLinkClick}

                                  >

                                    {productionTerminology.manageTitle}

                                  </Link>

                                </li>

                              )}

                              {hasPermission(

                                "Gestion Commerciale.Approvisionnement.Production.Historique.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/production/history"

                                    onClick={handleLinkClick}

                                  >

                                    {productionTerminology.historyTitle}

                                  </Link>

                                </li>

                              )}

                              {selectedCompanyIsRestaurant &&
                                hasPermission(
                                  "Gestion Commerciale.Restauration.Cuisine.view"
                                ) && (
                                  <li>
                                    <Link
                                      to="/production/kitchen"
                                      onClick={handleLinkClick}
                                    >
                                      File cuisine
                                    </Link>
                                  </li>
                                )}

                            </ul>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {(hasPermission("Gestion Commerciale.Ventes.Ventes.view") ||

                    hasPermission(

                      "Gestion Commerciale.Ventes.RetourVente.view"

                    ) ||

                    hasPermission(

                      "Gestion Commerciale.Ventes.ProformaDevis.view"

                    ) ||

                    hasPermission(

                      "Gestion Commerciale.Ventes.PaiementsEntrants.view"

                    ) ||

                    (selectedCompanyIsRestaurant &&

                      hasPermission(

                        "Gestion Commerciale.Restauration.MenuDigital.view"

                      )) ||

                    (selectedCompanyIsRestaurant &&

                      hasPermission(

                        "Gestion Commerciale.Restauration.CommandesSalle.view"

                      ))) && (

                    <li className="has-submenu" data-submenu-name="ventes">

                      <a href="#" onClick={(e) => toggleSubmenu("ventes", e)}>

                        <ShoppingOutlined className="menu-icon" /> Gestion

                        Ventes{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.ventes ? "open" : ""

                          }`}

                        >

                          {openSubmenus.ventes ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.ventes ? "visible" : ""

                        }`}

                      >

                        {" "}

                        {selectedCompanyIsRestaurant &&

                          hasPermission(

                            "Gestion Commerciale.Restauration.CommandesSalle.view"

                          ) && (

                            <li>

                              <Link

                                to="/gestion-ventes/commandes-restaurant"

                                onClick={handleLinkClick}

                              >

                                Prise de commande

                              </Link>

                            </li>

                          )}

                        {selectedCompanyIsRestaurant &&

                          hasPermission(

                            "Gestion Commerciale.Restauration.MenuDigital.view"

                          ) && (

                            <li>

                              <Link

                                to="/gestion-ventes/menu-digital"

                                onClick={handleLinkClick}

                              >

                                Menu digital

                              </Link>

                            </li>

                          )}

                        {hasPermission(

                          "Gestion Commerciale.Ventes.Ventes.view"

                        ) && (

                          <li>

                            <Link to="/gestion-ventes/ventes" onClick={handleLinkClick}>

                              Ventes

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Ventes.RetourVente.view"

                        ) && (

                          <li>

                            <Link to="/gestion-ventes/retour-vente" onClick={handleLinkClick}>

                              Retour de vente

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Ventes.Livraisons.view"

                        ) && (

                          <li>

                            <Link to="/gestion-ventes/livraisons" onClick={handleLinkClick}>

                              Livraisons

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Ventes.ProformaDevis.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-ventes/proforma"

                              onClick={handleLinkClick}

                            >

                              Proforma/Devis

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Ventes.PaiementsEntrants.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-ventes/paiements-entrants"

                              onClick={handleLinkClick}

                            >

                              Paiements Entrants

                            </Link>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {(hasPermission(

                    "Gestion Commerciale.Stock.GestionStock.Transfer.view"

                  ) ||

                    hasPermission(

                      "Gestion Commerciale.Stock.GestionStock.Adjust.view"

                    ) ||

                    hasPermission(

                      "Gestion Commerciale.Stock.GestionStock.History.view"

                    )) && (

                    <li className="has-submenu" data-submenu-name="stock">

                      <a href="#" onClick={(e) => toggleSubmenu("stock", e)}>

                        <DropboxOutlined className="menu-icon" /> Gestion Stock{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.stock ? "open" : ""

                          }`}

                        >

                          {openSubmenus.stock ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.stock ? "visible" : ""

                        }`}

                      >

                        {" "}

                        {(hasPermission(

                          "Gestion Commerciale.Stock.GestionStock.Transfer.view"

                        ) ||

                          hasPermission(

                            "Gestion Commerciale.Stock.GestionStock.Adjust.view"

                          ) ||

                          hasPermission(

                            "Gestion Commerciale.Stock.GestionStock.History.view"

                          )) && (

                          <li>

                            <Link to="/gestion-stock" onClick={handleLinkClick}>

                              <InteractionOutlined

                                style={{ marginRight: "8px" }}

                              />

                              Stock & Historique

                            </Link>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {hasAnyPermissionInModule(

                    "Gestion Commerciale.Tresorerie."

                  ) && (

                    <li>

                      <Link to="/caisse-banques" onClick={handleLinkClick}>

                        <BankOutlined className="menu-icon" /> Trésoreries

                      </Link>

                    </li>

                  )}

                  {(hasPermission(

                    "Gestion Commerciale.Depenses.Categories.view"

                  ) ||

                    hasPermission(

                      "Gestion Commerciale.Depenses.SaisieDepenses.view"

                    )) && (

                    <li className="has-submenu" data-submenu-name="depenses">

                      <a href="#" onClick={(e) => toggleSubmenu("depenses", e)}>

                        <WalletOutlined className="menu-icon" /> Charges Admin{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.depenses ? "open" : ""

                          }`}

                        >

                          {openSubmenus.depenses ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.depenses ? "visible" : ""

                        }`}

                      >

                        {" "}

                        {hasPermission(

                          "Gestion Commerciale.Depenses.Categories.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-charges-admin/categories"

                              onClick={handleLinkClick}

                            >

                              Categories Charges Admin

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Depenses.SaisieDepenses.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-charges-admin/saisie"

                              onClick={handleLinkClick}

                            >

                              Saisie Charges Admin

                            </Link>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {(hasPermission(

                    "Gestion Commerciale.Ecommerce.CommandesEnLigne.view"

                  ) ||

                    hasAnyPermissionInModule(

                      "Gestion Commerciale.Ecommerce.Configuration."

                    )) && (

                    <li className="has-submenu" data-submenu-name="ecommerce">

                      <a

                        href="#"

                        onClick={(e) => toggleSubmenu("ecommerce", e)}

                      >

                        <GlobalOutlined className="menu-icon" /> E-commerce{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.ecommerce ? "open" : ""

                          }`}

                        >

                          {openSubmenus.ecommerce ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.ecommerce ? "visible" : ""

                        }`}

                      >

                        {" "}

                        {hasPermission(

                          "Gestion Commerciale.Ecommerce.CommandesEnLigne.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-ecommerce/commandes-en-ligne"

                              onClick={handleLinkClick}

                            >

                              Commandes en ligne

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Gestion Commerciale.Ecommerce.CommandesEnLigne.view"

                        ) && (

                          <li>

                            <Link

                              to="/gestion-ecommerce/avis-clients"

                              onClick={handleLinkClick}

                            >

                              Gestion des Avis

                            </Link>

                          </li>

                        )}

                        {hasAnyPermissionInModule(

                          "Gestion Commerciale.Ecommerce.Configuration."

                        ) && (

                          <li

                            className="has-submenu"

                            data-submenu-name="ecommerce-config"

                          >

                            <a

                              href="#"

                              onClick={(e) =>

                                toggleSubmenu("ecommerce-config", e)

                              }

                            >

                              Configuration du site{" "}

                              <span

                                className={`submenu-indicator submenu-indicator-right ${

                                  openSubmenus["ecommerce-config"] ? "open" : ""

                                }`}

                              >

                                {openSubmenus["ecommerce-config"] ? "\u25B4" : "\u25BE"}

                              </span>

                            </a>

                            <ul

                              className={`submenu3 ${

                                openSubmenus["ecommerce-config"]

                                  ? "visible"

                                  : ""

                              }`}

                            >

                              {" "}

                              {hasPermission(

                                "Gestion Commerciale.Ecommerce.Configuration.FichesProduit.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/gestion-ecommerce/fiches-produit"

                                    onClick={handleLinkClick}

                                  >

                                    Fiches produit

                                  </Link>

                                </li>

                              )}

                              {hasPermission(

                                "Gestion Commerciale.Ecommerce.Configuration.Boutiques.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/gestion-ecommerce/configuration-boutique"

                                    onClick={handleLinkClick}

                                  >

                                    Configuration boutique

                                  </Link>

                                </li>

                              )}

                              {hasPermission(

                                "Gestion Commerciale.Ecommerce.Configuration.Frontend.view"

                              ) && (

                                <li>

                                  <Link

                                    to="/gestion-ecommerce/parametres-frontend"

                                    onClick={handleLinkClick}

                                  >

                                    Paramètres frontend

                                  </Link>

                                </li>

                              )}

                            </ul>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {canAccessCommercialReports && (

                    <li>

                      <Link to="/rapport" onClick={handleLinkClick}>

                        <BarChartOutlined className="menu-icon" /> Rapport

                      </Link>

                    </li>

                  )}

                  {hasPermission("Gestion Commerciale.POS.use") && (

                    <li>

                      <Link to="/gestion-pos" onClick={handleLinkClick}>

                        <ShopOutlined className="menu-icon" /> Point de vente

                      </Link>

                    </li>

                  )}

                </ul>

              </li>

            )}

            {hasPermission("Finance.TresorerieConsolidee.view") && (

              <li className="menu-item has-submenu" data-submenu-name="menuGlobal">

                <span onClick={(e) => toggleSubmenu("menuGlobal", e)}>

                  <BankOutlined className="menu-icon" /> Menu global{" "}

                  <span

                    className={`submenu-indicator ${

                      openSubmenus.menuGlobal ? "open" : ""

                    }`}

                  >

                    {openSubmenus.menuGlobal ? "\u25B4" : "\u25BE"}

                  </span>

                </span>

                <ul

                  className={`submenu submenu--menu-global ${

                    openSubmenus.menuGlobal ? "visible" : ""

                  }`}

                >

                  <li>

                    <Link to="/tresorerie-consolidee" onClick={handleLinkClick}>

                      <BankOutlined className="menu-icon" /> Trésorerie consolidée

                    </Link>

                  </li>

                </ul>

              </li>

            )}



            {/* --- RESSOURCES HUMAINES --- */}

            {hasAnyPermissionInModule("Ressources Humaines.") && (

              <li className="menu-item has-submenu" data-submenu-name="rh">

                <span onClick={(e) => toggleSubmenu("rh", e)}>

                  <TeamOutlined className="menu-icon" /> Ressources Humaines{" "}

                  <span

                    className={`submenu-indicator ${

                      openSubmenus.rh ? "open" : ""

                    }`}

                  >

                    {openSubmenus.rh ? "\u25B4" : "\u25BE"}

                  </span>

                </span>

                <ul className={`submenu ${openSubmenus.rh ? "visible" : ""}`}>

                  {hasPermission("Ressources Humaines.Dashboard.view") && (

                    <li>

                      <Link to="/rh/tableau-de-bord" onClick={handleLinkClick}>

                        <DashboardOutlined className="menu-icon" /> Tableau de

                        bord RH

                      </Link>

                    </li>

                  )}

                  {(hasPermission(

                    "Ressources Humaines.Personnel.Employes.view"

                  ) ||

                    hasPermission(

                      "Ressources Humaines.Personnel.Departements.view"

                    ) ||

                    hasPermission(

                      "Ressources Humaines.Personnel.Postes.view"

                    ) ||

                    hasPermission(

                      "Ressources Humaines.Personnel.Contrats.view"

                    )) && (

                    <li className="has-submenu" data-submenu-name="rhPersonnel">

                      <a

                        href="#"

                        onClick={(e) => toggleSubmenu("rhPersonnel", e)}

                      >

                        <UserOutlined className="menu-icon" /> Gestion Personnel{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.rhPersonnel ? "open" : ""

                          }`}

                        >

                          {openSubmenus.rhPersonnel ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.rhPersonnel ? "visible" : ""

                        }`}

                      >

                        {hasPermission(

                          "Ressources Humaines.Personnel.Employes.view"

                        ) && (

                          <li>

                            <Link to="/rh/employes" onClick={handleLinkClick}>

                              Employés

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Personnel.Departements.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/departements"

                              onClick={handleLinkClick}

                            >

                              Départements

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Personnel.Postes.view"

                        ) && (

                          <li>

                            <Link to="/rh/postes" onClick={handleLinkClick}>

                              Postes

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Personnel.Contrats.view"

                        ) && (

                          <li>

                            <Link to="/rh/contrats" onClick={handleLinkClick}>

                              Contrats

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Personnel.Contrats.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/types-contrats"

                              onClick={handleLinkClick}

                            >

                              Types de contrats

                            </Link>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {hasAnyPermissionInModule("Ressources Humaines.Paie.") && (

                    <li className="has-submenu" data-submenu-name="rhPaie">

                      <a href="#" onClick={(e) => toggleSubmenu("rhPaie", e)}>

                        <WalletOutlined className="menu-icon" /> Paie &

                        Rémunération{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.rhPaie ? "open" : ""

                          }`}

                        >

                          {openSubmenus.rhPaie ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.rhPaie ? "visible" : ""

                        }`}

                      >

                        {hasPermission(

                          "Ressources Humaines.Paie.TraitementPaie.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/traitement-paie"

                              onClick={handleLinkClick}

                            >

                              Traitement de paie

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Paie.Bulletins.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/bulletins-paie"

                              onClick={handleLinkClick}

                            >

                              Bulletins de paie

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Paie.Elements.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/elements-paie"

                              onClick={handleLinkClick}

                            >

                              Éléments de paie

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Paie.TaxesLegislation.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/taxes-legislation"

                              onClick={handleLinkClick}

                            >

                              Taxes et Législation

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Paie.TaxesLegislation.manage"

                        ) && (

                          <li>

                            <Link

                              to="/rh/taxes-legislation/manager"

                              onClick={handleLinkClick}

                            >

                              Législation Fiscale

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Paie.AvantagesNature.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/avantages-nature"

                              onClick={handleLinkClick}

                            >

                              Avantages en Nature

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Paie.Grilles.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/grilles-salariales"

                              onClick={handleLinkClick}

                            >

                              Grilles salariales

                            </Link>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {hasAnyPermissionInModule("Ressources Humaines.Temps.") && (

                    <li className="has-submenu" data-submenu-name="rhTemps">

                      <a href="#" onClick={(e) => toggleSubmenu("rhTemps", e)}>

                        <BankOutlined className="menu-icon" /> Temps & Présence{" "}

                        <span

                          className={`submenu-indicator submenu-indicator-right ${

                            openSubmenus.rhTemps ? "open" : ""

                          }`}

                        >

                          {openSubmenus.rhTemps ? "\u25B4" : "\u25BE"}

                        </span>

                      </a>

                      <ul

                        className={`submenu2 ${

                          openSubmenus.rhTemps ? "visible" : ""

                        }`}

                      >

                        {hasPermission(

                          "Ressources Humaines.Temps.Pointage.view"

                        ) && (

                          <li>

                            <Link to="/rh/pointage" onClick={handleLinkClick}>

                              Pointage

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Temps.Conges.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/conges-absences"

                              onClick={handleLinkClick}

                            >

                              Congés & absences

                            </Link>

                          </li>

                        )}

                        {hasPermission(

                          "Ressources Humaines.Temps.HeuresSupp.view"

                        ) && (

                          <li>

                            <Link

                              to="/rh/heures-supplementaires"

                              onClick={handleLinkClick}

                            >

                              Heures supplémentaires

                            </Link>

                          </li>

                        )}

                        {(hasPermission(

                          "Ressources Humaines.Temps.Planning.view"

                        ) || hasPermission("Ressources Humaines.Temps.Planning.manage_access")) && (

                          <li>

                            <Link to="/rh/planning" onClick={handleLinkClick}>

                              Planning de travail

                            </Link>

                          </li>

                        )}

                      </ul>

                    </li>

                  )}

                  {hasPermission("Ressources Humaines.Rapports.view") && (

                    <li>

                      <Link to="/rh/rapports" onClick={handleLinkClick}>

                        <BarChartOutlined className="menu-icon" /> Rapports &

                        Déclarations

                      </Link>

                    </li>

                  )}

                </ul>

              </li>

            )}



            {/* --- LOGISTIQUE / FREIGHT FORWARDING --- */}

            {hasAnyPermissionInModule("logistics.") && (

              <li className="menu-item has-submenu" data-submenu-name="logistics">

                <span onClick={(e) => toggleSubmenu("logistics", e)}>

                  <ContainerOutlined className="menu-icon" /> Logistique{" "}

                  <span

                    className={`submenu-indicator ${

                      openSubmenus.logistics ? "open" : ""

                    }`}

                  >

                    {openSubmenus.logistics ? "\u25B4" : "\u25BE"}

                  </span>

                </span>

                <ul className={`submenu ${openSubmenus.logistics ? "visible" : ""}`}>

                  {hasPermission("logistics.dashboard.view") && (

                    <li>

                      <Link to="/logistique/tableau-de-bord" onClick={handleLinkClick}>

                        <DashboardOutlined className="menu-icon" /> Tableau de bord

                      </Link>

                    </li>

                  )}

                  {hasPermission("logistics.shipments.view") && (

                    <li>

                      <Link to="/logistique/dossiers" onClick={handleLinkClick}>

                        <FileTextOutlined className="menu-icon" /> Dossiers

                      </Link>

                    </li>

                  )}

                  {hasPermission("logistics.customer_payments.view") && (
                    <li><Link to="/logistique/paiements-entrants" onClick={handleLinkClick}>
                      <DollarCircleOutlined className="menu-icon" /> Paiements Entrants
                    </Link></li>
                  )}
                  {(hasPermission("logistics.supplier_payments.view") || hasPermission("logistics.expenses.entries.view_payments")) && (
                    <li><Link to="/logistique/paiements-sortants" onClick={handleLinkClick}>
                      <DollarCircleOutlined className="menu-icon" /> Paiements Sortants
                    </Link></li>
                  )}
                  {hasPermission("logistics.treasury.view") && (

                    <li>

                      <Link

                        to="/logistique/tresorerie"

                        onClick={handleLinkClick}

                      >

                        <DollarCircleOutlined className="menu-icon" /> Trésorerie

                      </Link>

                    </li>

                  )}
                  {(hasPermission("logistics.expenses.entries.view") ||
                    hasPermission("logistics.expenses.categories.view")) && (
                    <li>
                      <Link to="/logistique/depenses" onClick={handleLinkClick}>
                        <WalletOutlined className="menu-icon" /> Charges Admin
                      </Link>
                    </li>
                  )}


                  {hasPermission("logistics.reports.view") && (

                    <li>

                      <Link to="/logistique/rapports" onClick={handleLinkClick}>

                        <BarChartOutlined className="menu-icon" /> Rapports

                      </Link>

                    </li>

                  )}

                  {hasPermission("logistics.account_masters.view") && (

                    <li>

                      <Link to="/logistique/configuration" onClick={handleLinkClick}>

                        <SettingOutlined className="menu-icon" /> Configuration

                      </Link>

                    </li>

                  )}

                </ul>

              </li>

            )}



            {/* --- HOTELLERIE --- */}

            {hasAnyPermissionInModule("Hotellerie.") && (

              <li className="menu-item has-submenu" data-submenu-name="hotellerie">

                <span onClick={(e) => toggleSubmenu("hotellerie", e)}>

                  <ApartmentOutlined className="menu-icon" /> Hotellerie{" "}

                  <span

                    className={`submenu-indicator ${

                      openSubmenus.hotellerie ? "open" : ""

                    }`}

                  >

                    {openSubmenus.hotellerie ? "\u25B4" : "\u25BE"}

                  </span>

                </span>

                <ul className={`submenu ${openSubmenus.hotellerie ? "visible" : ""}`}>

                  {hasPermission("Hotellerie.Reservations.view") && (

                    <li>

                      <Link to="/hotellerie?tab=reservations" onClick={handleLinkClick}>

                        <CalendarOutlined className="menu-icon" /> Reservations

                      </Link>

                    </li>

                  )}

                  {hasPermission("Hotellerie.Configuration.Chambres.view") && (

                    <li>

                      <Link to="/hotellerie?tab=rooms" onClick={handleLinkClick}>

                        <HomeOutlined className="menu-icon" /> Chambres & disponibilites

                      </Link>

                    </li>

                  )}

                  {(hasPermission("Hotellerie.Tarifs.PlansTarifaires.view") ||

                    hasPermission("Hotellerie.Tarifs.Calendrier.view")) && (

                    <li>

                      <Link to="/hotellerie?tab=rates" onClick={handleLinkClick}>

                        <DollarCircleOutlined className="menu-icon" /> Tarifs

                      </Link>

                    </li>

                  )}

                  {hasPermission("Hotellerie.Clients.view") && (

                    <li>

                      <Link to="/hotellerie?tab=guests" onClick={handleLinkClick}>

                        <TeamOutlined className="menu-icon" /> Clients

                      </Link>

                    </li>

                  )}

                  {hasPermission("Hotellerie.Comptes.view") && (

                    <li>

                      <Link to="/hotellerie?tab=accounts" onClick={handleLinkClick}>

                        <BankOutlined className="menu-icon" /> Comptes

                      </Link>

                    </li>

                  )}

                  {hasPermission("Hotellerie.Folios.view") && (

                    <li>

                      <Link to="/hotellerie?tab=folios" onClick={handleLinkClick}>

                        <FileTextOutlined className="menu-icon" /> Folios

                      </Link>

                    </li>

                  )}

                  {hasPermission("Hotellerie.Services.view") && (

                    <li>

                      <Link to="/hotellerie?tab=services" onClick={handleLinkClick}>

                        <AppstoreOutlined className="menu-icon" /> Services

                      </Link>

                    </li>

                  )}

                  {(hasPermission("Hotellerie.Operations.Housekeeping.view") ||

                    hasPermission("Hotellerie.Operations.Maintenance.view")) && (

                    <li>

                      <Link to="/hotellerie?tab=operations" onClick={handleLinkClick}>

                        <ToolOutlined className="menu-icon" /> Operations

                      </Link>

                    </li>

                  )}

                  {hasPermission("Hotellerie.Paiements.view") && (

                    <li>

                      <Link to="/hotellerie?tab=payments" onClick={handleLinkClick}>

                        <DollarCircleOutlined className="menu-icon" /> Paiements

                      </Link>

                    </li>

                  )}
                  {(hasPermission("Hotellerie.Depenses.Categories.view") ||
                    hasPermission("Hotellerie.Depenses.SaisieDepenses.view")) && (
                    <li>
                      <Link to="/hotellerie?tab=expenses" onClick={handleLinkClick}>
                        <WalletOutlined className="menu-icon" /> Charges Admin
                      </Link>
                    </li>
                  )}


                  {(hasPermission("Hotellerie.Configuration.Proprietes.view") ||

                    hasPermission("Hotellerie.Configuration.Batiments.view") ||

                    hasPermission("Hotellerie.Configuration.Etages.view") ||

                    hasPermission("Hotellerie.Configuration.TypesChambres.view") ||

                    hasPermission("Hotellerie.Configuration.Amenites.view")) && (

                    <li>

                      <Link to="/hotellerie?tab=configuration" onClick={handleLinkClick}>

                        <SettingOutlined className="menu-icon" /> Configuration

                      </Link>

                    </li>

                  )}

                </ul>

              </li>

            )}



            {/* --- ADMIN --- */}

            {hasAnyPermissionInModule("Admin.") && (

              <li className="menu-item has-submenu" data-submenu-name="admin">

                <span onClick={(e) => toggleSubmenu("admin", e)}>

                  <SettingOutlined className="menu-icon" /> Admin{" "}

                  <span

                    className={`submenu-indicator ${

                      openSubmenus.admin ? "open" : ""

                    }`}

                  >

                    {openSubmenus.admin ? "\u25B4" : "\u25BE"}

                  </span>

                </span>

                <ul

                  className={`submenu ${openSubmenus.admin ? "visible" : ""}`}

                >

                  {" "}

                  {hasPermission("Souscription.MonAbonnement.view") && (

                    <li>

                      <Link to="/souscription" onClick={handleLinkClick}>

                        <IdcardOutlined className="menu-icon" />{" "}

                        {user?.is_superadmin ? "Souscriptions" : "Ma souscription"}

                      </Link>

                    </li>

                  )}

                  {hasPermission("Admin.GestionEntreprises.view") && (

                    <li>

                      <Link to="/gestion-entreprises" onClick={handleLinkClick}>

                        <BankOutlined className="menu-icon" /> Gestion

                        Entreprises

                      </Link>

                    </li>

                  )}

                  {hasPermission("Admin.GestionUtilisateurs.view") && (

                    <li>

                      <Link to="/gestion-personnel" onClick={handleLinkClick}>

                        <UserOutlined className="menu-icon" /> Utilisateurs

                      </Link>

                    </li>

                  )}

                  {hasPermission("Admin.Magasins.view") && (

                    <li>

                      <Link to="/gestion-magasin" onClick={handleLinkClick}>

                        <ShopOutlined className="menu-icon" /> Établissement

                      </Link>

                    </li>

                  )}

                  {hasPermission("Admin.RolesPermissions.view") && (

                    <li>

                      <Link

                        to="/gestion-roles-permissions"

                        onClick={handleLinkClick}

                      >

                        <KeyOutlined className="menu-icon" /> Rôles et

                        permissions

                      </Link>

                    </li>

                  )}

                  {hasPermission("Admin.Taxes.view") && (

                    <li>

                      <Link to="/gestion-taxes" onClick={handleLinkClick}>

                        <PercentageOutlined className="menu-icon" /> Taxes

                      </Link>

                    </li>

                  )}

                  {hasPermission("Admin.Devises.view") && (

                    <li>

                      <Link to="/gestion-devise" onClick={handleLinkClick}>

                        <DollarCircleOutlined className="menu-icon" /> Devise

                      </Link>

                    </li>

                  )}

                  {hasPermission("Admin.ModesPaiement.view") && (

                    <li>

                      <Link

                        to="/gestion-mode-paiement"

                        onClick={handleLinkClick}

                      >

                        <CreditCardOutlined className="menu-icon" /> Mode de

                        paiement

                      </Link>

                    </li>

                  )}

                  {(user?.is_superadmin ||

                    hasPermission("Notifications.manage_settings")) && (

                    <li>

                      <Link

                        to="/notification-settings"

                        onClick={handleLinkClick}

                      >

                        <BellOutlined className="menu-icon" /> Notifications

                      </Link>

                    </li>

                  )}

                  {Number(user?.is_superadmin) === 1 && (
                    <li>
                      <Link to="/retours-utilisateurs" onClick={handleLinkClick}>
                        <CommentOutlined className="menu-icon" /> Retours utilisateurs
                      </Link>
                    </li>
                  )}

                  {Boolean(user?.is_superadmin) && (

                    <li>

                      <Link

                        to="/server-monitoring"

                        onClick={handleLinkClick}

                      >

                        <MonitorOutlined className="menu-icon" /> Monitoring Serveur

                      </Link>

                    </li>

                  )}

                  {Boolean(user?.is_superadmin) && (

                    <li>

                      <Link

                        to="/backup-monitoring"

                        onClick={handleLinkClick}

                      >

                        <DropboxOutlined className="menu-icon" /> Sauvegardes

                      </Link>

                    </li>

                  )}

                  {Boolean(user?.is_superadmin) && (

                    <li>

                      <Link

                        to="/recipe-assistant-settings"

                        onClick={handleLinkClick}

                      >

                        <SettingOutlined className="menu-icon" /> Réglages Moteur Recettes

                      </Link>

                    </li>

                  )}

                  {(user?.is_superadmin || user?.permissions?.includes("view_audit_logs")) && (

                    <li>

                      <Link

                        to="/audit/dashboard"

                        onClick={handleLinkClick}

                      >

                        <AuditOutlined className="menu-icon" /> Journal d'Audit

                      </Link>

                    </li>

                  )}

                </ul>

              </li>

            )}



          </ul>

          <ul className="menu desktop-menu desktop-menu--actions">
            <li className="menu-item header-theme-toggle">

              <ThemeToggle size="middle" showLabel={false} />

            </li>

            <li className="menu-item header-user-pill">

              <button

                type="button"

                className="header-user-pill__button"

                onClick={() => setIsProfileModalVisible(true)}

                title={`${userProfileLabel} — Mon profil`}
                aria-label={`${userProfileLabel} — Ouvrir mon profil`}

              >

                <Avatar

                  size="small"

                  src={user?.profile_image && !imageError ? getImageUrl(user.profile_image) : undefined}

                  icon={<UserOutlined />}

                  onError={() => setImageError(true)}

                  onLoad={() => setImageError(false)}

                />

                <span className="pill-text">

                  {userProfileLabel}

                </span>

              </button>

            </li>

            {/* Affiche la cloche de notification seulement si l'utilisateur est admin ou a la permission */}

            {(user?.is_superadmin || hasPermission("Notifications.view")) && (

              <li className="menu-item notification-menu-item">

                <NotificationBell />

              </li>

            )}

            <li className="menu-item logout-menu-item">

              <a

                href="#"

                onClick={handleLogout}

                className="logout-link"

                title="Déconnexion"

                aria-label="Déconnexion"

              >

                <LogoutOutlined className="logout-icon" />

              </a>

            </li>

          </ul>

        </nav>

      </header>
      )}

      {!useMobileShell && (
      <div className="top-section-below-header app-context-bar">

        {/* Layout responsive unifié */}



        {/* Mobile : Badge d'essai en haut */}

        <div className="app-context-bar__mobile-badge sm:hidden flex justify-center mb-3">

          <TrialCountdownBadge

            size="small"

            showLabel={true}

            centered={true}

            className="trial-countdown-badge-mobile"

            onUpgradeClick={() => {

              setPricingModalVisible(true);

            }}

          />

        </div>



        {/* Layout principal : Grid responsive */}

        <div className="grid grid-cols-1 sm:grid-cols-3 items-center gap-3 top-section-grid">

          {/* Section gauche reservee : le profil utilisateur est dans le header desktop. */}

          <div className="top-section-grid__left" />



          {/* Section centrale : Badge d'essai (desktop seulement) */}

          <div className="hidden sm:flex sm:justify-center top-section-grid__center">

            <TrialCountdownBadge

              size="default"

              showLabel={true}

              centered={true}

              onUpgradeClick={() => {

                setPricingModalVisible(true);

              }}

            />

          </div>



          {/* Section droite : Notifications et sélecteurs */}

          <div className="flex justify-end items-center gap-3 top-section-grid__right">

            <div className="app-context-bar__desktop-context">
              <RightSideNav />
            </div>

            <div className="app-context-bar__mobile-context">
              <MobileContextSelectors />
            </div>

          </div>

        </div>

      </div>
      )}

      <NetworkStatusBanner />

      <SubscriptionBillingBanner />

      {useMobileShell && !user?.is_superadmin &&
        location.pathname.startsWith("/souscription") && (
          <MobileContextSelectors />
        )}

      <main className="main-content">

        <Outlet
          context={{
            openMobileMenu: () => setMobileMenuOpen(true),
            homeShortcutMenuTree: menuTreeData,
          }}
        />

      </main>

      {isMobileViewport && (
        <MobileBottomNav
          onMenu={toggleMobileMenu}
          menuOpen={mobileMenuOpen}
          homeLabel={
            selectedCompanyIsRestaurant &&
            hasPermission("Gestion Commerciale.Dashboard.view")
              ? "Pilotage"
              : "Accueil"
          }
        />
      )}



      {/* Modal de tarification */}

      <PricingModal

        visible={pricingModalVisible}

        onClose={() => setPricingModalVisible(false)}

      />



      {/* Modal de profil utilisateur (mobile uniquement) */}

      <UserProfileModal

        visible={isProfileModalVisible}

        onCancel={() => setIsProfileModalVisible(false)}

      />

      <DailyRecapBriefingManager
        blocked={pricingModalVisible || isProfileModalVisible}
      />

      <FeedbackWidget blocked={mobileMenuOpen || pricingModalVisible || isProfileModalVisible} />

    </div>

  );

};



const CompanySuspensionNotificationBridge = ({ children }) => {
  const [noticeApi, contextHolder] = notification.useNotification();

  useLayoutEffect(
    () => setCompanySuspensionNotificationApi(noticeApi),
    [noticeApi],
  );

  return <>{contextHolder}{children}</>;
};

// --- Wrapper Ant Design Theme ---

// Composant intermédiaire pour accéder au thème dans ConfigProvider

const AntdThemeWrapper = ({ children }) => {

  const { isDarkMode } = useTheme();



  // Configuration du thème Ant Design basée sur isDarkMode

  const antdTheme = {

    algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,

    token: {

      colorPrimary: '#173F5F',        // Marine principal ELSA

      colorLink: '#173F5F',           // Liens

      colorSuccess: '#52c41a',        // Succès (vert Ant Design par défaut)

      colorWarning: '#faad14',        // Warning (orange Ant Design par défaut)

      colorError: '#C93033',          // Rouge fonctionnel accessible

      colorInfo: '#295D86',           // Bleu secondaire ELSA (infos)

      fontSize: 14,

      borderRadius: 4,

    },

  };



  return (

    <ConfigProvider theme={antdTheme}>

      <CompanySuspensionNotificationBridge>{children}</CompanySuspensionNotificationBridge>

    </ConfigProvider>

  );

};



// --- Composant Principal App ---

const App = () => {

  return (

    <HelmetProvider>

      {" "}

      {/* Needed for react-helmet-async */}

      <SelectionProvider>

        <ThemeProvider>

          <AuthProvider>

            <NotificationUnreadProvider>

              <AntdThemeWrapper>

                <Router>

                  <AppRoutes />

                </Router>

              </AntdThemeWrapper>

            </NotificationUnreadProvider>

          </AuthProvider>

        </ThemeProvider>

      </SelectionProvider>

    </HelmetProvider>

  );

};



// Create a new component to handle conditional routing based on auth state

const CONNECTIVITY_AUTH_PATHS = new Set([
  "/login",
  "/forgot-password",
  "/reset-password",
  "/signup",
  "/payment",
]);

const AppRoutes = () => {

  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const showAuthConnectivity =
    CONNECTIVITY_AUTH_PATHS.has(location.pathname) &&
    (!isAuthenticated || location.pathname === "/payment");



  SecureLogger.debug(

    `AppRoutes state: loading=${isLoading}, authenticated=${isAuthenticated}`

  );



  if (isLoading) {

    return (
      <>
        {showAuthConnectivity && <NetworkStatusBanner floating />}
        <div className="flex justify-center items-center h-screen text-xl">
          Chargement de l'application...
        </div>
      </>
    );

  }



  return (
    <>
      {showAuthConnectivity && <NetworkStatusBanner floating />}
      <Routes>

      {/* Login Route */}

      <Route

        path="/login"

        element={

          isAuthenticated ? <Navigate to="/accueil" replace /> : <Login />

        }

      />



      {/* Payment Route */}

      <Route path="/payment" element={<PaymentPage />} />



      <Route

        path="/forgot-password"

        element={<ForgotPassword />}

      />



      <Route

        path="/reset-password"

        element={<ResetPassword />}

      />



      {/* Signup/Registration Route */}

      <Route

        path="/signup"

        element={

          isAuthenticated ? <Navigate to="/accueil" replace /> : <Signup />

        }

      />



      {/* Pages légales */}

      <Route path="/terms-of-service" element={<TermsOfService />} />

      <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      <Route path="/cookie-policy" element={<CookiePolicy />} />

      <Route path="/legal" element={<LegalNotice />} />

      <Route path="/gdpr" element={<GDPR />} />



      {/* Page d'accès refusé */}

      <Route

        path="/acces-refuse"

        element={

          <ProtectedRoute>

            <AccessDeniedPage />

          </ProtectedRoute>

        }

      />



      {/* Protected Routes - Main Application Layout */}

      {/* This should catch all other paths intended for the authenticated app */}

      <Route

        path="/*"

        element={

          isAuthenticated ? (

            <MainAppLayout />

          ) : window.location.pathname === "/" ? (

            <RestaurantLandingPage />

          ) : (

            <Navigate to="/login" replace />

          )

        }

      >

        {/* Default route for authenticated users if MainAppLayout is hit via /* but no sub-path matched */}

        {/* This index route under /* is now more critical */}

        <Route index element={<Navigate to="/accueil" replace />} />



        {/* All your existing protected routes are defined here, nested under MainAppLayout */}

        <Route path="accueil" element={<HomePage />} />

        <Route path="gestion-produits" element={<ProductTabsLayout />}>
          <Route index element={<ProductTabsRedirect />} />
          <Route
            path="marques"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Produits.Marques.view">
                <ResponsiveBrands />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="categories"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Produits.Categories.view">
                <ResponsiveCategories />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="produits"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Produits.Produits.view">
                <ResponsiveGestionProduit />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="services"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Services.view">
                <ResponsiveServices />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="rendez-vous"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.RendezVous.view">
                <ResponsiveRendezVous />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="unites"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Produits.Unites.view">
                <ResponsiveUnits />
              </PermissionProtectedRoute>
            }
          />
        </Route>
        <Route
          path="gestion-services"
          element={<Navigate to="/gestion-produits/services" replace />}
        />
        <Route
          path="gestion-rendez-vous"
          element={<Navigate to="/gestion-produits/rendez-vous" replace />}
        />

        <Route
          path="gestion-brands"
          element={<Navigate to="/gestion-produits/marques" replace />}
        />

        <Route
          path="gestion-categories"
          element={<Navigate to="/gestion-produits/categories" replace />}
        />

        <Route path="gestion-entites" element={<EntityTabsLayout />}>
          <Route index element={<EntityTabsRedirect />} />
          <Route
            path="clients"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Entites.Clients.view">
                <ResponsiveEntites entityType="customer" />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="fournisseurs"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Entites.Fournisseurs.view">
                <ResponsiveEntites entityType="supplier" />
              </PermissionProtectedRoute>
            }
          />
        </Route>

        <Route path="gestion-achats" element={<PurchaseTabsLayout />}>
          <Route index element={<PurchaseTabsRedirect />} />
          <Route
            path="achat"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Achats.Achat.view">
                <ResponsiveGestionAchat />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="bon-commande"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Achats.BonCommande.view">
                <GestionBonCommande />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="retour-achat"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Achats.RetourAchat.view">
                <ResponsiveRetourAchat />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="paiements-sortants"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.view">
                <ResponsivePaymentSortant />
              </PermissionProtectedRoute>
            }
          />
        </Route>
        <Route
          path="gestion-achat"
          element={<Navigate to="/gestion-achats/achat" replace />}
        />
        <Route
          path="gestion-bon-commande"
          element={<Navigate to="/gestion-achats/bon-commande" replace />}
        />
        <Route
          path="retour-achat"
          element={<Navigate to="/gestion-achats/retour-achat" replace />}
        />
        <Route
          path="paiements-sortants"
          element={<Navigate to="/gestion-achats/paiements-sortants" replace />}
        />

        <Route path="gestion-ventes" element={<SalesTabsLayout />}>
          <Route index element={<SalesTabsRedirect />} />
          <Route
            path="ventes"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ventes.Ventes.view">
                <ResponsiveGestionVente />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="retour-vente"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ventes.RetourVente.view">
                <ResponsiveRetourVente />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="livraisons"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ventes.Livraisons.view">
                <ResponsiveLivraisons />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="proforma"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ventes.ProformaDevis.view">
                <ResponsiveProforma />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="paiements-entrants"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ventes.PaiementsEntrants.view">
                <ResponsivePaymentEntrant />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="commandes-restaurant"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Restauration.CommandesSalle.view">
                <RestaurantOrders />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="menu-digital"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Restauration.MenuDigital.view">
                <RestaurantDigitalMenu />
              </PermissionProtectedRoute>
            }
          />
        </Route>
        <Route
          path="gestion-vente"
          element={<Navigate to="/gestion-ventes/ventes" replace />}
        />

        <Route path="gestion-pos" element={<GestionPos />} />

        <Route path="gestion-entreprises" element={<ResponsiveGestionCompanies />} />

        <Route path="gestion-personnel" element={<ResponsiveGestionStaff />} />

        <Route path="gestion-magasin" element={<ResponsiveGestionMagasin />} />

        <Route

          path="gestion-roles-permissions"

          element={<ResponsiveGestionRolesPermissions />}

        />

        <Route path="gestion-taxes" element={<ResponsiveGestionTaxes />} />

        <Route path="gestion-devise" element={<ResponsiveGestionDevise />} />

        <Route path="gestion-mode-paiement" element={<ResponsiveGestionModePaiement />} />

        <Route
          path="gestion-unites"
          element={<Navigate to="/gestion-produits/unites" replace />}
        />

        <Route
          path="paiements-entrants"
          element={<Navigate to="/gestion-ventes/paiements-entrants" replace />}
        />

        <Route
          path="retour-vente"
          element={<Navigate to="/gestion-ventes/retour-vente" replace />}
        />

        <Route
          path="gestion-proforma"
          element={<Navigate to="/gestion-ventes/proforma" replace />}
        />

        <Route path="production" element={<ProductionTabsLayout />}>
          <Route index element={<ProductionLandingRedirect />} />
          <Route
            path="units"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Production.Unites.view">
                <ResponsiveProductionUnits />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="units/create"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Production.Unites.create">
                <ProductionUnitForm />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="units/edit/:id"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Production.Unites.edit">
                <ProductionUnitForm />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="process"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Production.Gerer.view">
                <ResponsiveProductionProcess />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="process/batch"
            element={
              <PermissionProtectedRoute
                requiredPermission={[
                  "Gestion Commerciale.Approvisionnement.Production.Gerer.view",
                  "Gestion Commerciale.Approvisionnement.Production.Gerer.create",
                ]}
              >
                <ProductionBatchProcess />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="process/:id"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Production.Gerer.view">
                <ResponsiveProductionProcess />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="kitchen"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Restauration.Cuisine.view">
                <ProductionKitchen />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="kitchen/process"
            element={
              <PermissionProtectedRoute
                requiredPermission={[
                  "Gestion Commerciale.Restauration.Cuisine.convert_to_production",
                  "Gestion Commerciale.Approvisionnement.Production.Gerer.create",
                  "Gestion Commerciale.Approvisionnement.Production.Gerer.view",
                ]}
              >
                <ProductionProcess restaurantMode />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="kitchen/batch"
            element={
              <PermissionProtectedRoute
                requiredPermission={[
                  "Gestion Commerciale.Restauration.Cuisine.convert_to_production",
                  "Gestion Commerciale.Approvisionnement.Production.Gerer.create",
                ]}
              >
                <ProductionBatchProcess restaurantMode />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="history"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Production.Historique.view">
                <ResponsiveProductionHistory />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="regularization"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Production.Gerer.create">
                <ProductionRegularization />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="equipment"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Approvisionnement.Production.Materiels.view">
                <ProductionEquipmentList />
              </PermissionProtectedRoute>
            }
          />
        </Route>

        <Route path="gestion-stock" element={<ResponsiveGestionStock />} />

        <Route path="caisse-banques" element={<ResponsiveGestionTresorerie />} />

        <Route

          path="tresorerie-consolidee"

          element={

            <PermissionProtectedRoute requiredPermission="Finance.TresorerieConsolidee.view">

              <ResponsiveGestionTresorerieConsolidee />

            </PermissionProtectedRoute>

          }

        />

        <Route path="gestion-charges-admin" element={<AdminExpensesTabsLayout />}>
          <Route index element={<AdminExpensesTabsRedirect />} />
          <Route
            path="categories"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Depenses.Categories.view">
                <ResponsiveGestionCategoriesDepenses />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="saisie"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Depenses.SaisieDepenses.view">
                <ResponsiveGestionSaisieDepenses />
              </PermissionProtectedRoute>
            }
          />
        </Route>

        <Route
          path="categories-depenses"
          element={<Navigate to="/gestion-charges-admin/categories" replace />}
        />

        <Route
          path="saisie-depenses"
          element={<Navigate to="/gestion-charges-admin/saisie" replace />}
        />

        <Route path="gestion-ecommerce" element={<EcommerceTabsLayout />}>
          <Route index element={<EcommerceTabsRedirect />} />
          <Route
            path="commandes-en-ligne"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ecommerce.CommandesEnLigne.view">
                <ResponsiveCommandesEnLigne />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="fiches-produit"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ecommerce.Configuration.FichesProduit.view">
                <ResponsiveProduitsEnLigne />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="parametres-frontend"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ecommerce.Configuration.Frontend.view">
                <ResponsiveParametresBoutique />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="configuration-boutique"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ecommerce.Configuration.Boutiques.view">
                <ResponsiveConfigurationBoutique />
              </PermissionProtectedRoute>
            }
          />
          <Route
            path="avis-clients"
            element={
              <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Ecommerce.CommandesEnLigne.view">
                <ResponsiveGestionAvis />
              </PermissionProtectedRoute>
            }
          />
        </Route>

        <Route
          path="commandes-en-ligne"
          element={<Navigate to="/gestion-ecommerce/commandes-en-ligne" replace />}
        />

        <Route
          path="fiches-produit"
          element={<Navigate to="/gestion-ecommerce/fiches-produit" replace />}
        />

        <Route
          path="parametres-frontend"
          element={<Navigate to="/gestion-ecommerce/parametres-frontend" replace />}
        />

        <Route
          path="configuration-boutique"
          element={<Navigate to="/gestion-ecommerce/configuration-boutique" replace />}
        />

        <Route
          path="avis-clients"
          element={<Navigate to="/gestion-ecommerce/avis-clients" replace />}
        />

        <Route

          path="rapport"

          element={

            <PermissionProtectedRoute requiredPermission={COMMERCIAL_REPORT_VIEW_PERMISSIONS}>

              <CommercialReports />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="souscription"

          element={

            <PermissionProtectedRoute requiredPermission="Souscription.MonAbonnement.view">

              <GestionSouscription />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="souscription/plans"

          element={

            <SysAdminProtectedRoute>

              <PermissionProtectedRoute requiredPermission="Admin.Souscription.Plans.view">

                <SubscriptionPlans />

              </PermissionProtectedRoute>

            </SysAdminProtectedRoute>

          }

        />

        <Route

          path="souscription/transactions"

          element={

            <SysAdminProtectedRoute>

              <PermissionProtectedRoute requiredPermission="Admin.Souscription.Transactions.view">

                <TransactionHistory />

              </PermissionProtectedRoute>

            </SysAdminProtectedRoute>

          }

        />

        <Route

          path="souscription/dashboard"

          element={

            <SysAdminProtectedRoute>

              <PermissionProtectedRoute requiredPermission="Admin.Souscription.Reports.view">

                <SubscriptionDashboard />

              </PermissionProtectedRoute>

            </SysAdminProtectedRoute>

          }

        />

        <Route

          path="souscription/factures"

          element={

            <SysAdminProtectedRoute>

              <PermissionProtectedRoute requiredPermission="Admin.Souscription.Invoices.view">

                <GestionFactures />

              </PermissionProtectedRoute>

            </SysAdminProtectedRoute>

          }

        />

        <Route

          path="notification-settings"

          element={

            <PermissionProtectedRoute requiredPermission="Notifications.manage_settings">

              <NotificationSettings />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="notifications"

          element={

            <PermissionProtectedRoute requiredPermission="Notifications.view">

              <ResponsiveNotifications />

            </PermissionProtectedRoute>

          }

        />

        {/* Routes RH - Tableau de bord */}

        <Route

          path="rh/tableau-de-bord"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Dashboard.view">

              <HRDashboardWrapper />

            </PermissionProtectedRoute>

          }

        />



        {/* Routes RH - Personnel */}

        <Route

          path="rh/employes"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Personnel.Employes.view">

              <EmployeeListWrapper />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/departements"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Personnel.Departements.view">

              <DepartmentListWrapper />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/postes"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Personnel.Postes.view">

              <PositionListWrapper />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/contrats"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Personnel.Contrats.view">

              <ContractListWrapper />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/types-contrats"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Personnel.Contrats.view">

              <ContractTypeListWrapper />

            </PermissionProtectedRoute>

          }

        />



        {/* Routes RH - Paie */}

        <Route

          path="rh/traitement-paie"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Paie.TraitementPaie.view">

              <PayrollProcessing />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/bulletins-paie"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Paie.Bulletins.view">

              <PayslipListWrapper />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/elements-paie"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Paie.Elements.view">

              <PayrollItemsList />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/taxes-legislation"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Paie.TaxesLegislation.view">

              <TaxLegislationList />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/taxes-legislation/company"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Paie.TaxesLegislation.view">

              <CompanyLegislationDashboard />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/taxes-legislation/manager"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Paie.TaxesLegislation.manage">

              <CompanyLegislationManager />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/avantages-nature"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Paie.AvantagesNature.view">

              <NaturaBenefitsWrapper />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/grilles-salariales"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Paie.Grilles.view">

              <div className="p-6">

                <h1 className="text-2xl font-bold">Grilles Salariales</h1>

                <p className="text-gray-600">En cours de développement...</p>

              </div>

            </PermissionProtectedRoute>

          }

        />



        {/* Routes RH - Temps & Présence */}

        <Route

          path="rh/pointage"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Temps.Pointage.view">

              <div className="p-6">

                <h1 className="text-2xl font-bold">Pointage</h1>

                <p className="text-gray-600">En cours de développement...</p>

              </div>

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/conges-absences"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Temps.Conges.view">

              <div className="p-6">

                <h1 className="text-2xl font-bold">Congés & Absences</h1>

                <p className="text-gray-600">En cours de développement...</p>

              </div>

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/heures-supplementaires"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Temps.HeuresSupp.view">

              <div className="p-6">

                <h1 className="text-2xl font-bold">Heures Supplémentaires</h1>

                <p className="text-gray-600">En cours de développement...</p>

              </div>

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="rh/planning"

          element={

            <PermissionProtectedRoute requiredPermission={["Ressources Humaines.Temps.Planning.view", "Ressources Humaines.Temps.Planning.manage_access"]}>

              <PlanningWorkspace />

            </PermissionProtectedRoute>

          }

        />

        

        {/* Routes RH - Rapports */}

        <Route

          path="rh/rapports"

          element={

            <PermissionProtectedRoute requiredPermission="Ressources Humaines.Rapports.view">

              <ReportsWrapper />

            </PermissionProtectedRoute>

          }

        />



        {/* Routes Hotellerie */}

        <Route

          path="hotellerie"

          element={

            <ModuleProtectedRoute modulePrefix="Hotellerie.">

              <GestionHotellerie />

            </ModuleProtectedRoute>

          }

        />



        {/* Routes Logistique - Freight Forwarding */}
        <Route path="logistique/paiements-entrants" element={
          <PermissionProtectedRoute requiredPermission="logistics.customer_payments.view">
            <LogisticsPayments paymentType="in" />
          </PermissionProtectedRoute>
        } />
        <Route path="logistique/paiements-sortants" element={
          <PermissionProtectedRoute requiredPermission={["logistics.supplier_payments.view", "logistics.expenses.entries.view_payments"]}>
            <LogisticsPayments paymentType="out" />
          </PermissionProtectedRoute>
        } />

        <Route

          path="logistique/tableau-de-bord"

          element={

            <PermissionProtectedRoute requiredPermission="logistics.dashboard.view">

              <ResponsiveLogisticsDashboard />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="logistique/dossiers"

          element={

            <PermissionProtectedRoute requiredPermission="logistics.shipments.view">

              <ResponsiveShipmentList />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="logistique/tresorerie"

          element={

            <PermissionProtectedRoute requiredPermission="logistics.treasury.view">

              <ResponsiveLogisticsTreasury />

            </PermissionProtectedRoute>

          }

        />
        <Route

          path="logistique/depenses"

          element={

            <ModuleProtectedRoute modulePrefix="logistics.expenses.">

              <ResponsiveLogisticsExpenses />

            </ModuleProtectedRoute>

          }

        />


        <Route

          path="logistics/shipment/:id"

          element={

            <PermissionProtectedRoute requiredPermission="logistics.shipments.view">

              <ResponsiveShipmentDetail />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="logistique/configuration"

          element={

            <PermissionProtectedRoute requiredPermission="logistics.account_masters.view">

              <ResponsiveAccountMasterManager />

            </PermissionProtectedRoute>

          }

        />

        <Route

          path="logistique/rapports"

          element={

            <PermissionProtectedRoute requiredPermission="logistics.reports.view">

              <ResponsiveShipmentReports />

            </PermissionProtectedRoute>

          }

        />



        <Route

          path="tableau-de-bord"

          element={

            <PermissionProtectedRoute requiredPermission="Gestion Commerciale.Dashboard.view">

              <Dashboard />

            </PermissionProtectedRoute>

          }

        />

        <Route path="guides" element={<GuidesLandingPage />} />

        <Route path="guides/:guideSlug" element={<GuideDetailPage />} />

        <Route path="support" element={<SupportPage />} />
        <Route path="retours-utilisateurs" element={<FeedbackInbox />} />



        {/* Route Monitoring Serveur - SuperAdmin uniquement */}

        <Route

          path="server-monitoring"

          element={<ServerMonitoring />}

        />



        {/* Route Sauvegardes MySQL - SuperAdmin uniquement */}

        <Route

          path="backup-monitoring"

          element={<BackupMonitoring />}

        />



        {/* Route Réglages Moteur Recettes - SuperAdmin uniquement */}

        <Route

          path="recipe-assistant-settings"

          element={<RecipeAssistantSettings />}

        />



        {/* Routes Audit Log - Admin/SuperAdmin uniquement */}

        <Route
          path="audit"
          element={
            <PermissionProtectedRoute requiredPermission="view_audit_logs">
              <AuditTabsLayout />
            </PermissionProtectedRoute>
          }
        >
          <Route index element={<AuditTabsRedirect />} />
          <Route path="dashboard" element={<ResponsiveAuditDashboard />} />
          <Route path="logs" element={<ResponsiveAuditLogs />} />
          <Route path="connexions" element={<ResponsiveAuditConnections />} />
          <Route path="sessions" element={<ResponsiveAuditSessions />} />
        </Route>

        <Route
          path="audit-dashboard"
          element={<Navigate to="/audit/dashboard" replace />}
        />

        <Route
          path="audit-logs"
          element={<Navigate to="/audit/logs" replace />}
        />



        {/* Catch-all for any other paths within the authenticated app's MainAppLayout */}

        {/* This ensures that if an authenticated user types a non-existent path like /dfgdfg, they see this */}

        <Route

          path="*"

          element={

            <div style={{ padding: "2rem", textAlign: "center" }}>

              <h1>404 - Page Introuvable dans l'application</h1>

              <p>La page que vous cherchez n'existe pas.</p>

              <Link to="/accueil">Retour à l'accueil</Link>

            </div>

          }

        />

      </Route>



      {/* Routes publiques pour les boutiques e-commerce */}

      <Route path="/store/:storeSlug" element={<StoreFront />} />

      <Route path="/store/:storeSlug/product/:productId" element={<StoreFront />} />

      <Route path="/store/:storeSlug/checkout" element={<Checkout />} />

      <Route path="/store/:storeSlug/payment/return" element={<PaymentReturn />} />

      <Route path="/menu/:menuSlug" element={<PublicMenu />} />

      <Route
        path="/menu/:menuSlug/order/:publicOrderToken"
        element={<PublicMenu />}
      />

      <Route path="/review" element={<ReviewPage />} />

      </Routes>
    </>

  );

};



export default App;
